var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFluentEmojiSunset(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent-emoji:sunset"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    filter: "url(#filter0_i_434_3634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.5 2H6.5C4.29086 2 2.5 3.79086 2.5 6V26C2.5 28.2091 4.29086 30 6.5 30H26.5C28.7091 30 30.5 28.2091 30.5 26V6C30.5 3.79086 28.7091 2 26.5 2Z",
    fill: "url(#paint0_linear_434_3634)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    filter: "url(#filter1_f_434_3634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27 4.22998C27.544 4.31098 28.632 4.94798 28.632 6.83998V19.326",
    stroke: "url(#paint1_linear_434_3634)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.8422 4.01001C19.0528 3.78083 19.3088 3.59787 19.5938 3.47268C19.8788 3.34749 20.1867 3.28281 20.498 3.28271C20.8092 3.28262 21.1172 3.34712 21.4023 3.47214C21.6873 3.59715 21.9434 3.77996 22.1542 4.00901L22.7322 4.63801C22.8251 4.73881 22.9397 4.81706 23.0675 4.8668C23.1952 4.91654 23.3326 4.93645 23.4692 4.92501L24.5602 4.83301C25.1525 4.78308 25.7405 4.96978 26.1955 5.35227C26.6505 5.73477 26.9355 6.28191 26.9882 6.87401L27.0332 7.37501C27.047 7.52919 27.1004 7.67721 27.1882 7.80473C27.2759 7.93226 27.3951 8.035 27.5342 8.10301L28.2922 8.47301C28.5886 8.61778 28.8496 8.82602 29.0565 9.08296C29.2635 9.3399 29.4113 9.63924 29.4896 9.95973C29.5678 10.2802 29.5746 10.614 29.5094 10.9374C29.4441 11.2608 29.3085 11.5659 29.1122 11.831L28.9122 12.103C28.7981 12.2574 28.7364 12.4442 28.736 12.6362C28.7356 12.8281 28.7967 13.0152 28.9102 13.17L29.1302 13.47C29.3314 13.7443 29.4677 14.0606 29.5289 14.3952C29.5901 14.7298 29.5746 15.0739 29.4835 15.4017C29.3925 15.7294 29.2282 16.0322 29.0031 16.2872C28.7781 16.5423 28.498 16.7429 28.1842 16.874L27.4322 17.188C27.2929 17.2463 27.1706 17.3387 27.0764 17.4566C26.9822 17.5746 26.9192 17.7143 26.8932 17.863L26.6802 19.08C26.5994 19.5397 26.3432 19.9501 25.9655 20.2244C25.5878 20.4987 25.1183 20.6154 24.6562 20.55L23.3842 20.37C23.2485 20.3508 23.1101 20.3629 22.9798 20.4054C22.8495 20.4478 22.7306 20.5195 22.6322 20.615L21.7092 21.509C21.3738 21.8339 20.9251 22.0156 20.4582 22.0156C19.9912 22.0156 19.5426 21.8339 19.2072 21.509L18.2842 20.615C18.1857 20.5197 18.0668 20.4482 17.9364 20.4059C17.8061 20.3636 17.6678 20.3517 17.5322 20.371L16.2362 20.554C15.7782 20.6192 15.3128 20.5054 14.9366 20.2363C14.5604 19.9672 14.3024 19.5635 14.2162 19.109L13.9872 17.902C13.9605 17.762 13.901 17.6304 13.8136 17.5179C13.7261 17.4055 13.6132 17.3153 13.4842 17.255L12.8182 16.945C12.5314 16.8114 12.2761 16.6188 12.0689 16.3798C11.8617 16.1408 11.7073 15.8607 11.6157 15.5579C11.5242 15.2551 11.4976 14.9364 11.5376 14.6227C11.5777 14.3089 11.6835 14.0071 11.8482 13.737L12.1962 13.167C12.2858 13.0198 12.3313 12.8499 12.3272 12.6776C12.3232 12.5053 12.2697 12.3378 12.1732 12.195L11.9072 11.8C11.7122 11.511 11.5871 11.1805 11.5419 10.8348C11.4966 10.4891 11.5324 10.1376 11.6463 9.80807C11.7603 9.47856 11.9494 9.18008 12.1986 8.93623C12.4478 8.69237 12.7503 8.50982 13.0822 8.40301L13.3962 8.30301C13.5657 8.2481 13.7152 8.14409 13.8255 8.00417C13.9359 7.86424 14.0023 7.69469 14.0162 7.51701L14.0862 6.63601C14.1127 6.30081 14.2141 5.97583 14.3829 5.68502C14.5517 5.39421 14.7836 5.14496 15.0615 4.95564C15.3393 4.76632 15.6562 4.64175 15.9886 4.59111C16.321 4.54046 16.6605 4.56503 16.9822 4.66301L17.4262 4.79801C17.5883 4.84723 17.761 4.8497 17.9245 4.80512C18.0879 4.76054 18.2355 4.67073 18.3502 4.54601L18.8422 4.01001Z",
    fill: "url(#paint2_linear_434_3634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.8422 4.01001C19.0528 3.78083 19.3088 3.59787 19.5938 3.47268C19.8788 3.34749 20.1867 3.28281 20.498 3.28271C20.8092 3.28262 21.1172 3.34712 21.4023 3.47214C21.6873 3.59715 21.9434 3.77996 22.1542 4.00901L22.7322 4.63801C22.8251 4.73881 22.9397 4.81706 23.0675 4.8668C23.1952 4.91654 23.3326 4.93645 23.4692 4.92501L24.5602 4.83301C25.1525 4.78308 25.7405 4.96978 26.1955 5.35227C26.6505 5.73477 26.9355 6.28191 26.9882 6.87401L27.0332 7.37501C27.047 7.52919 27.1004 7.67721 27.1882 7.80473C27.2759 7.93226 27.3951 8.035 27.5342 8.10301L28.2922 8.47301C28.5886 8.61778 28.8496 8.82602 29.0565 9.08296C29.2635 9.3399 29.4113 9.63924 29.4896 9.95973C29.5678 10.2802 29.5746 10.614 29.5094 10.9374C29.4441 11.2608 29.3085 11.5659 29.1122 11.831L28.9122 12.103C28.7981 12.2574 28.7364 12.4442 28.736 12.6362C28.7356 12.8281 28.7967 13.0152 28.9102 13.17L29.1302 13.47C29.3314 13.7443 29.4677 14.0606 29.5289 14.3952C29.5901 14.7298 29.5746 15.0739 29.4835 15.4017C29.3925 15.7294 29.2282 16.0322 29.0031 16.2872C28.7781 16.5423 28.498 16.7429 28.1842 16.874L27.4322 17.188C27.2929 17.2463 27.1706 17.3387 27.0764 17.4566C26.9822 17.5746 26.9192 17.7143 26.8932 17.863L26.6802 19.08C26.5994 19.5397 26.3432 19.9501 25.9655 20.2244C25.5878 20.4987 25.1183 20.6154 24.6562 20.55L23.3842 20.37C23.2485 20.3508 23.1101 20.3629 22.9798 20.4054C22.8495 20.4478 22.7306 20.5195 22.6322 20.615L21.7092 21.509C21.3738 21.8339 20.9251 22.0156 20.4582 22.0156C19.9912 22.0156 19.5426 21.8339 19.2072 21.509L18.2842 20.615C18.1857 20.5197 18.0668 20.4482 17.9364 20.4059C17.8061 20.3636 17.6678 20.3517 17.5322 20.371L16.2362 20.554C15.7782 20.6192 15.3128 20.5054 14.9366 20.2363C14.5604 19.9672 14.3024 19.5635 14.2162 19.109L13.9872 17.902C13.9605 17.762 13.901 17.6304 13.8136 17.5179C13.7261 17.4055 13.6132 17.3153 13.4842 17.255L12.8182 16.945C12.5314 16.8114 12.2761 16.6188 12.0689 16.3798C11.8617 16.1408 11.7073 15.8607 11.6157 15.5579C11.5242 15.2551 11.4976 14.9364 11.5376 14.6227C11.5777 14.3089 11.6835 14.0071 11.8482 13.737L12.1962 13.167C12.2858 13.0198 12.3313 12.8499 12.3272 12.6776C12.3232 12.5053 12.2697 12.3378 12.1732 12.195L11.9072 11.8C11.7122 11.511 11.5871 11.1805 11.5419 10.8348C11.4966 10.4891 11.5324 10.1376 11.6463 9.80807C11.7603 9.47856 11.9494 9.18008 12.1986 8.93623C12.4478 8.69237 12.7503 8.50982 13.0822 8.40301L13.3962 8.30301C13.5657 8.2481 13.7152 8.14409 13.8255 8.00417C13.9359 7.86424 14.0023 7.69469 14.0162 7.51701L14.0862 6.63601C14.1127 6.30081 14.2141 5.97583 14.3829 5.68502C14.5517 5.39421 14.7836 5.14496 15.0615 4.95564C15.3393 4.76632 15.6562 4.64175 15.9886 4.59111C16.321 4.54046 16.6605 4.56503 16.9822 4.66301L17.4262 4.79801C17.5883 4.84723 17.761 4.8497 17.9245 4.80512C18.0879 4.76054 18.2355 4.67073 18.3502 4.54601L18.8422 4.01001Z",
    fill: "url(#paint3_radial_434_3634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.8422 4.01001C19.0528 3.78083 19.3088 3.59787 19.5938 3.47268C19.8788 3.34749 20.1867 3.28281 20.498 3.28271C20.8092 3.28262 21.1172 3.34712 21.4023 3.47214C21.6873 3.59715 21.9434 3.77996 22.1542 4.00901L22.7322 4.63801C22.8251 4.73881 22.9397 4.81706 23.0675 4.8668C23.1952 4.91654 23.3326 4.93645 23.4692 4.92501L24.5602 4.83301C25.1525 4.78308 25.7405 4.96978 26.1955 5.35227C26.6505 5.73477 26.9355 6.28191 26.9882 6.87401L27.0332 7.37501C27.047 7.52919 27.1004 7.67721 27.1882 7.80473C27.2759 7.93226 27.3951 8.035 27.5342 8.10301L28.2922 8.47301C28.5886 8.61778 28.8496 8.82602 29.0565 9.08296C29.2635 9.3399 29.4113 9.63924 29.4896 9.95973C29.5678 10.2802 29.5746 10.614 29.5094 10.9374C29.4441 11.2608 29.3085 11.5659 29.1122 11.831L28.9122 12.103C28.7981 12.2574 28.7364 12.4442 28.736 12.6362C28.7356 12.8281 28.7967 13.0152 28.9102 13.17L29.1302 13.47C29.3314 13.7443 29.4677 14.0606 29.5289 14.3952C29.5901 14.7298 29.5746 15.0739 29.4835 15.4017C29.3925 15.7294 29.2282 16.0322 29.0031 16.2872C28.7781 16.5423 28.498 16.7429 28.1842 16.874L27.4322 17.188C27.2929 17.2463 27.1706 17.3387 27.0764 17.4566C26.9822 17.5746 26.9192 17.7143 26.8932 17.863L26.6802 19.08C26.5994 19.5397 26.3432 19.9501 25.9655 20.2244C25.5878 20.4987 25.1183 20.6154 24.6562 20.55L23.3842 20.37C23.2485 20.3508 23.1101 20.3629 22.9798 20.4054C22.8495 20.4478 22.7306 20.5195 22.6322 20.615L21.7092 21.509C21.3738 21.8339 20.9251 22.0156 20.4582 22.0156C19.9912 22.0156 19.5426 21.8339 19.2072 21.509L18.2842 20.615C18.1857 20.5197 18.0668 20.4482 17.9364 20.4059C17.8061 20.3636 17.6678 20.3517 17.5322 20.371L16.2362 20.554C15.7782 20.6192 15.3128 20.5054 14.9366 20.2363C14.5604 19.9672 14.3024 19.5635 14.2162 19.109L13.9872 17.902C13.9605 17.762 13.901 17.6304 13.8136 17.5179C13.7261 17.4055 13.6132 17.3153 13.4842 17.255L12.8182 16.945C12.5314 16.8114 12.2761 16.6188 12.0689 16.3798C11.8617 16.1408 11.7073 15.8607 11.6157 15.5579C11.5242 15.2551 11.4976 14.9364 11.5376 14.6227C11.5777 14.3089 11.6835 14.0071 11.8482 13.737L12.1962 13.167C12.2858 13.0198 12.3313 12.8499 12.3272 12.6776C12.3232 12.5053 12.2697 12.3378 12.1732 12.195L11.9072 11.8C11.7122 11.511 11.5871 11.1805 11.5419 10.8348C11.4966 10.4891 11.5324 10.1376 11.6463 9.80807C11.7603 9.47856 11.9494 9.18008 12.1986 8.93623C12.4478 8.69237 12.7503 8.50982 13.0822 8.40301L13.3962 8.30301C13.5657 8.2481 13.7152 8.14409 13.8255 8.00417C13.9359 7.86424 14.0023 7.69469 14.0162 7.51701L14.0862 6.63601C14.1127 6.30081 14.2141 5.97583 14.3829 5.68502C14.5517 5.39421 14.7836 5.14496 15.0615 4.95564C15.3393 4.76632 15.6562 4.64175 15.9886 4.59111C16.321 4.54046 16.6605 4.56503 16.9822 4.66301L17.4262 4.79801C17.5883 4.84723 17.761 4.8497 17.9245 4.80512C18.0879 4.76054 18.2355 4.67073 18.3502 4.54601L18.8422 4.01001Z",
    fill: "url(#paint4_radial_434_3634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18.8422 4.01001C19.0528 3.78083 19.3088 3.59787 19.5938 3.47268C19.8788 3.34749 20.1867 3.28281 20.498 3.28271C20.8092 3.28262 21.1172 3.34712 21.4023 3.47214C21.6873 3.59715 21.9434 3.77996 22.1542 4.00901L22.7322 4.63801C22.8251 4.73881 22.9397 4.81706 23.0675 4.8668C23.1952 4.91654 23.3326 4.93645 23.4692 4.92501L24.5602 4.83301C25.1525 4.78308 25.7405 4.96978 26.1955 5.35227C26.6505 5.73477 26.9355 6.28191 26.9882 6.87401L27.0332 7.37501C27.047 7.52919 27.1004 7.67721 27.1882 7.80473C27.2759 7.93226 27.3951 8.035 27.5342 8.10301L28.2922 8.47301C28.5886 8.61778 28.8496 8.82602 29.0565 9.08296C29.2635 9.3399 29.4113 9.63924 29.4896 9.95973C29.5678 10.2802 29.5746 10.614 29.5094 10.9374C29.4441 11.2608 29.3085 11.5659 29.1122 11.831L28.9122 12.103C28.7981 12.2574 28.7364 12.4442 28.736 12.6362C28.7356 12.8281 28.7967 13.0152 28.9102 13.17L29.1302 13.47C29.3314 13.7443 29.4677 14.0606 29.5289 14.3952C29.5901 14.7298 29.5746 15.0739 29.4835 15.4017C29.3925 15.7294 29.2282 16.0322 29.0031 16.2872C28.7781 16.5423 28.498 16.7429 28.1842 16.874L27.4322 17.188C27.2929 17.2463 27.1706 17.3387 27.0764 17.4566C26.9822 17.5746 26.9192 17.7143 26.8932 17.863L26.6802 19.08C26.5994 19.5397 26.3432 19.9501 25.9655 20.2244C25.5878 20.4987 25.1183 20.6154 24.6562 20.55L23.3842 20.37C23.2485 20.3508 23.1101 20.3629 22.9798 20.4054C22.8495 20.4478 22.7306 20.5195 22.6322 20.615L21.7092 21.509C21.3738 21.8339 20.9251 22.0156 20.4582 22.0156C19.9912 22.0156 19.5426 21.8339 19.2072 21.509L18.2842 20.615C18.1857 20.5197 18.0668 20.4482 17.9364 20.4059C17.8061 20.3636 17.6678 20.3517 17.5322 20.371L16.2362 20.554C15.7782 20.6192 15.3128 20.5054 14.9366 20.2363C14.5604 19.9672 14.3024 19.5635 14.2162 19.109L13.9872 17.902C13.9605 17.762 13.901 17.6304 13.8136 17.5179C13.7261 17.4055 13.6132 17.3153 13.4842 17.255L12.8182 16.945C12.5314 16.8114 12.2761 16.6188 12.0689 16.3798C11.8617 16.1408 11.7073 15.8607 11.6157 15.5579C11.5242 15.2551 11.4976 14.9364 11.5376 14.6227C11.5777 14.3089 11.6835 14.0071 11.8482 13.737L12.1962 13.167C12.2858 13.0198 12.3313 12.8499 12.3272 12.6776C12.3232 12.5053 12.2697 12.3378 12.1732 12.195L11.9072 11.8C11.7122 11.511 11.5871 11.1805 11.5419 10.8348C11.4966 10.4891 11.5324 10.1376 11.6463 9.80807C11.7603 9.47856 11.9494 9.18008 12.1986 8.93623C12.4478 8.69237 12.7503 8.50982 13.0822 8.40301L13.3962 8.30301C13.5657 8.2481 13.7152 8.14409 13.8255 8.00417C13.9359 7.86424 14.0023 7.69469 14.0162 7.51701L14.0862 6.63601C14.1127 6.30081 14.2141 5.97583 14.3829 5.68502C14.5517 5.39421 14.7836 5.14496 15.0615 4.95564C15.3393 4.76632 15.6562 4.64175 15.9886 4.59111C16.321 4.54046 16.6605 4.56503 16.9822 4.66301L17.4262 4.79801C17.5883 4.84723 17.761 4.8497 17.9245 4.80512C18.0879 4.76054 18.2355 4.67073 18.3502 4.54601L18.8422 4.01001Z",
    fill: "url(#paint5_radial_434_3634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M18.8422 4.01001C19.0528 3.78083 19.3088 3.59787 19.5938 3.47268C19.8788 3.34749 20.1867 3.28281 20.498 3.28271C20.8092 3.28262 21.1172 3.34712 21.4023 3.47214C21.6873 3.59715 21.9434 3.77996 22.1542 4.00901L22.7322 4.63801C22.8251 4.73881 22.9397 4.81706 23.0675 4.8668C23.1952 4.91654 23.3326 4.93645 23.4692 4.92501L24.5602 4.83301C25.1525 4.78308 25.7405 4.96978 26.1955 5.35227C26.6505 5.73477 26.9355 6.28191 26.9882 6.87401L27.0332 7.37501C27.047 7.52919 27.1004 7.67721 27.1882 7.80473C27.2759 7.93226 27.3951 8.035 27.5342 8.10301L28.2922 8.47301C28.5886 8.61778 28.8496 8.82602 29.0565 9.08296C29.2635 9.3399 29.4113 9.63924 29.4896 9.95973C29.5678 10.2802 29.5746 10.614 29.5094 10.9374C29.4441 11.2608 29.3085 11.5659 29.1122 11.831L28.9122 12.103C28.7981 12.2574 28.7364 12.4442 28.736 12.6362C28.7356 12.8281 28.7967 13.0152 28.9102 13.17L29.1302 13.47C29.3314 13.7443 29.4677 14.0606 29.5289 14.3952C29.5901 14.7298 29.5746 15.0739 29.4835 15.4017C29.3925 15.7294 29.2282 16.0322 29.0031 16.2872C28.7781 16.5423 28.498 16.7429 28.1842 16.874L27.4322 17.188C27.2929 17.2463 27.1706 17.3387 27.0764 17.4566C26.9822 17.5746 26.9192 17.7143 26.8932 17.863L26.6802 19.08C26.5994 19.5397 26.3432 19.9501 25.9655 20.2244C25.5878 20.4987 25.1183 20.6154 24.6562 20.55L23.3842 20.37C23.2485 20.3508 23.1101 20.3629 22.9798 20.4054C22.8495 20.4478 22.7306 20.5195 22.6322 20.615L21.7092 21.509C21.3738 21.8339 20.9251 22.0156 20.4582 22.0156C19.9912 22.0156 19.5426 21.8339 19.2072 21.509L18.2842 20.615C18.1857 20.5197 18.0668 20.4482 17.9364 20.4059C17.8061 20.3636 17.6678 20.3517 17.5322 20.371L16.2362 20.554C15.7782 20.6192 15.3128 20.5054 14.9366 20.2363C14.5604 19.9672 14.3024 19.5635 14.2162 19.109L13.9872 17.902C13.9605 17.762 13.901 17.6304 13.8136 17.5179C13.7261 17.4055 13.6132 17.3153 13.4842 17.255L12.8182 16.945C12.5314 16.8114 12.2761 16.6188 12.0689 16.3798C11.8617 16.1408 11.7073 15.8607 11.6157 15.5579C11.5242 15.2551 11.4976 14.9364 11.5376 14.6227C11.5777 14.3089 11.6835 14.0071 11.8482 13.737L12.1962 13.167C12.2858 13.0198 12.3313 12.8499 12.3272 12.6776C12.3232 12.5053 12.2697 12.3378 12.1732 12.195L11.9072 11.8C11.7122 11.511 11.5871 11.1805 11.5419 10.8348C11.4966 10.4891 11.5324 10.1376 11.6463 9.80807C11.7603 9.47856 11.9494 9.18008 12.1986 8.93623C12.4478 8.69237 12.7503 8.50982 13.0822 8.40301L13.3962 8.30301C13.5657 8.2481 13.7152 8.14409 13.8255 8.00417C13.9359 7.86424 14.0023 7.69469 14.0162 7.51701L14.0862 6.63601C14.1127 6.30081 14.2141 5.97583 14.3829 5.68502C14.5517 5.39421 14.7836 5.14496 15.0615 4.95564C15.3393 4.76632 15.6562 4.64175 15.9886 4.59111C16.321 4.54046 16.6605 4.56503 16.9822 4.66301L17.4262 4.79801C17.5883 4.84723 17.761 4.8497 17.9245 4.80512C18.0879 4.76054 18.2355 4.67073 18.3502 4.54601L18.8422 4.01001Z",
    fill: "url(#paint6_radial_434_3634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M18.8422 4.01001C19.0528 3.78083 19.3088 3.59787 19.5938 3.47268C19.8788 3.34749 20.1867 3.28281 20.498 3.28271C20.8092 3.28262 21.1172 3.34712 21.4023 3.47214C21.6873 3.59715 21.9434 3.77996 22.1542 4.00901L22.7322 4.63801C22.8251 4.73881 22.9397 4.81706 23.0675 4.8668C23.1952 4.91654 23.3326 4.93645 23.4692 4.92501L24.5602 4.83301C25.1525 4.78308 25.7405 4.96978 26.1955 5.35227C26.6505 5.73477 26.9355 6.28191 26.9882 6.87401L27.0332 7.37501C27.047 7.52919 27.1004 7.67721 27.1882 7.80473C27.2759 7.93226 27.3951 8.035 27.5342 8.10301L28.2922 8.47301C28.5886 8.61778 28.8496 8.82602 29.0565 9.08296C29.2635 9.3399 29.4113 9.63924 29.4896 9.95973C29.5678 10.2802 29.5746 10.614 29.5094 10.9374C29.4441 11.2608 29.3085 11.5659 29.1122 11.831L28.9122 12.103C28.7981 12.2574 28.7364 12.4442 28.736 12.6362C28.7356 12.8281 28.7967 13.0152 28.9102 13.17L29.1302 13.47C29.3314 13.7443 29.4677 14.0606 29.5289 14.3952C29.5901 14.7298 29.5746 15.0739 29.4835 15.4017C29.3925 15.7294 29.2282 16.0322 29.0031 16.2872C28.7781 16.5423 28.498 16.7429 28.1842 16.874L27.4322 17.188C27.2929 17.2463 27.1706 17.3387 27.0764 17.4566C26.9822 17.5746 26.9192 17.7143 26.8932 17.863L26.6802 19.08C26.5994 19.5397 26.3432 19.9501 25.9655 20.2244C25.5878 20.4987 25.1183 20.6154 24.6562 20.55L23.3842 20.37C23.2485 20.3508 23.1101 20.3629 22.9798 20.4054C22.8495 20.4478 22.7306 20.5195 22.6322 20.615L21.7092 21.509C21.3738 21.8339 20.9251 22.0156 20.4582 22.0156C19.9912 22.0156 19.5426 21.8339 19.2072 21.509L18.2842 20.615C18.1857 20.5197 18.0668 20.4482 17.9364 20.4059C17.8061 20.3636 17.6678 20.3517 17.5322 20.371L16.2362 20.554C15.7782 20.6192 15.3128 20.5054 14.9366 20.2363C14.5604 19.9672 14.3024 19.5635 14.2162 19.109L13.9872 17.902C13.9605 17.762 13.901 17.6304 13.8136 17.5179C13.7261 17.4055 13.6132 17.3153 13.4842 17.255L12.8182 16.945C12.5314 16.8114 12.2761 16.6188 12.0689 16.3798C11.8617 16.1408 11.7073 15.8607 11.6157 15.5579C11.5242 15.2551 11.4976 14.9364 11.5376 14.6227C11.5777 14.3089 11.6835 14.0071 11.8482 13.737L12.1962 13.167C12.2858 13.0198 12.3313 12.8499 12.3272 12.6776C12.3232 12.5053 12.2697 12.3378 12.1732 12.195L11.9072 11.8C11.7122 11.511 11.5871 11.1805 11.5419 10.8348C11.4966 10.4891 11.5324 10.1376 11.6463 9.80807C11.7603 9.47856 11.9494 9.18008 12.1986 8.93623C12.4478 8.69237 12.7503 8.50982 13.0822 8.40301L13.3962 8.30301C13.5657 8.2481 13.7152 8.14409 13.8255 8.00417C13.9359 7.86424 14.0023 7.69469 14.0162 7.51701L14.0862 6.63601C14.1127 6.30081 14.2141 5.97583 14.3829 5.68502C14.5517 5.39421 14.7836 5.14496 15.0615 4.95564C15.3393 4.76632 15.6562 4.64175 15.9886 4.59111C16.321 4.54046 16.6605 4.56503 16.9822 4.66301L17.4262 4.79801C17.5883 4.84723 17.761 4.8497 17.9245 4.80512C18.0879 4.76054 18.2355 4.67073 18.3502 4.54601L18.8422 4.01001Z",
    fill: "url(#paint7_radial_434_3634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M18.8422 4.01001C19.0528 3.78083 19.3088 3.59787 19.5938 3.47268C19.8788 3.34749 20.1867 3.28281 20.498 3.28271C20.8092 3.28262 21.1172 3.34712 21.4023 3.47214C21.6873 3.59715 21.9434 3.77996 22.1542 4.00901L22.7322 4.63801C22.8251 4.73881 22.9397 4.81706 23.0675 4.8668C23.1952 4.91654 23.3326 4.93645 23.4692 4.92501L24.5602 4.83301C25.1525 4.78308 25.7405 4.96978 26.1955 5.35227C26.6505 5.73477 26.9355 6.28191 26.9882 6.87401L27.0332 7.37501C27.047 7.52919 27.1004 7.67721 27.1882 7.80473C27.2759 7.93226 27.3951 8.035 27.5342 8.10301L28.2922 8.47301C28.5886 8.61778 28.8496 8.82602 29.0565 9.08296C29.2635 9.3399 29.4113 9.63924 29.4896 9.95973C29.5678 10.2802 29.5746 10.614 29.5094 10.9374C29.4441 11.2608 29.3085 11.5659 29.1122 11.831L28.9122 12.103C28.7981 12.2574 28.7364 12.4442 28.736 12.6362C28.7356 12.8281 28.7967 13.0152 28.9102 13.17L29.1302 13.47C29.3314 13.7443 29.4677 14.0606 29.5289 14.3952C29.5901 14.7298 29.5746 15.0739 29.4835 15.4017C29.3925 15.7294 29.2282 16.0322 29.0031 16.2872C28.7781 16.5423 28.498 16.7429 28.1842 16.874L27.4322 17.188C27.2929 17.2463 27.1706 17.3387 27.0764 17.4566C26.9822 17.5746 26.9192 17.7143 26.8932 17.863L26.6802 19.08C26.5994 19.5397 26.3432 19.9501 25.9655 20.2244C25.5878 20.4987 25.1183 20.6154 24.6562 20.55L23.3842 20.37C23.2485 20.3508 23.1101 20.3629 22.9798 20.4054C22.8495 20.4478 22.7306 20.5195 22.6322 20.615L21.7092 21.509C21.3738 21.8339 20.9251 22.0156 20.4582 22.0156C19.9912 22.0156 19.5426 21.8339 19.2072 21.509L18.2842 20.615C18.1857 20.5197 18.0668 20.4482 17.9364 20.4059C17.8061 20.3636 17.6678 20.3517 17.5322 20.371L16.2362 20.554C15.7782 20.6192 15.3128 20.5054 14.9366 20.2363C14.5604 19.9672 14.3024 19.5635 14.2162 19.109L13.9872 17.902C13.9605 17.762 13.901 17.6304 13.8136 17.5179C13.7261 17.4055 13.6132 17.3153 13.4842 17.255L12.8182 16.945C12.5314 16.8114 12.2761 16.6188 12.0689 16.3798C11.8617 16.1408 11.7073 15.8607 11.6157 15.5579C11.5242 15.2551 11.4976 14.9364 11.5376 14.6227C11.5777 14.3089 11.6835 14.0071 11.8482 13.737L12.1962 13.167C12.2858 13.0198 12.3313 12.8499 12.3272 12.6776C12.3232 12.5053 12.2697 12.3378 12.1732 12.195L11.9072 11.8C11.7122 11.511 11.5871 11.1805 11.5419 10.8348C11.4966 10.4891 11.5324 10.1376 11.6463 9.80807C11.7603 9.47856 11.9494 9.18008 12.1986 8.93623C12.4478 8.69237 12.7503 8.50982 13.0822 8.40301L13.3962 8.30301C13.5657 8.2481 13.7152 8.14409 13.8255 8.00417C13.9359 7.86424 14.0023 7.69469 14.0162 7.51701L14.0862 6.63601C14.1127 6.30081 14.2141 5.97583 14.3829 5.68502C14.5517 5.39421 14.7836 5.14496 15.0615 4.95564C15.3393 4.76632 15.6562 4.64175 15.9886 4.59111C16.321 4.54046 16.6605 4.56503 16.9822 4.66301L17.4262 4.79801C17.5883 4.84723 17.761 4.8497 17.9245 4.80512C18.0879 4.76054 18.2355 4.67073 18.3502 4.54601L18.8422 4.01001Z",
    fill: "url(#paint8_radial_434_3634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M18.8422 4.01001C19.0528 3.78083 19.3088 3.59787 19.5938 3.47268C19.8788 3.34749 20.1867 3.28281 20.498 3.28271C20.8092 3.28262 21.1172 3.34712 21.4023 3.47214C21.6873 3.59715 21.9434 3.77996 22.1542 4.00901L22.7322 4.63801C22.8251 4.73881 22.9397 4.81706 23.0675 4.8668C23.1952 4.91654 23.3326 4.93645 23.4692 4.92501L24.5602 4.83301C25.1525 4.78308 25.7405 4.96978 26.1955 5.35227C26.6505 5.73477 26.9355 6.28191 26.9882 6.87401L27.0332 7.37501C27.047 7.52919 27.1004 7.67721 27.1882 7.80473C27.2759 7.93226 27.3951 8.035 27.5342 8.10301L28.2922 8.47301C28.5886 8.61778 28.8496 8.82602 29.0565 9.08296C29.2635 9.3399 29.4113 9.63924 29.4896 9.95973C29.5678 10.2802 29.5746 10.614 29.5094 10.9374C29.4441 11.2608 29.3085 11.5659 29.1122 11.831L28.9122 12.103C28.7981 12.2574 28.7364 12.4442 28.736 12.6362C28.7356 12.8281 28.7967 13.0152 28.9102 13.17L29.1302 13.47C29.3314 13.7443 29.4677 14.0606 29.5289 14.3952C29.5901 14.7298 29.5746 15.0739 29.4835 15.4017C29.3925 15.7294 29.2282 16.0322 29.0031 16.2872C28.7781 16.5423 28.498 16.7429 28.1842 16.874L27.4322 17.188C27.2929 17.2463 27.1706 17.3387 27.0764 17.4566C26.9822 17.5746 26.9192 17.7143 26.8932 17.863L26.6802 19.08C26.5994 19.5397 26.3432 19.9501 25.9655 20.2244C25.5878 20.4987 25.1183 20.6154 24.6562 20.55L23.3842 20.37C23.2485 20.3508 23.1101 20.3629 22.9798 20.4054C22.8495 20.4478 22.7306 20.5195 22.6322 20.615L21.7092 21.509C21.3738 21.8339 20.9251 22.0156 20.4582 22.0156C19.9912 22.0156 19.5426 21.8339 19.2072 21.509L18.2842 20.615C18.1857 20.5197 18.0668 20.4482 17.9364 20.4059C17.8061 20.3636 17.6678 20.3517 17.5322 20.371L16.2362 20.554C15.7782 20.6192 15.3128 20.5054 14.9366 20.2363C14.5604 19.9672 14.3024 19.5635 14.2162 19.109L13.9872 17.902C13.9605 17.762 13.901 17.6304 13.8136 17.5179C13.7261 17.4055 13.6132 17.3153 13.4842 17.255L12.8182 16.945C12.5314 16.8114 12.2761 16.6188 12.0689 16.3798C11.8617 16.1408 11.7073 15.8607 11.6157 15.5579C11.5242 15.2551 11.4976 14.9364 11.5376 14.6227C11.5777 14.3089 11.6835 14.0071 11.8482 13.737L12.1962 13.167C12.2858 13.0198 12.3313 12.8499 12.3272 12.6776C12.3232 12.5053 12.2697 12.3378 12.1732 12.195L11.9072 11.8C11.7122 11.511 11.5871 11.1805 11.5419 10.8348C11.4966 10.4891 11.5324 10.1376 11.6463 9.80807C11.7603 9.47856 11.9494 9.18008 12.1986 8.93623C12.4478 8.69237 12.7503 8.50982 13.0822 8.40301L13.3962 8.30301C13.5657 8.2481 13.7152 8.14409 13.8255 8.00417C13.9359 7.86424 14.0023 7.69469 14.0162 7.51701L14.0862 6.63601C14.1127 6.30081 14.2141 5.97583 14.3829 5.68502C14.5517 5.39421 14.7836 5.14496 15.0615 4.95564C15.3393 4.76632 15.6562 4.64175 15.9886 4.59111C16.321 4.54046 16.6605 4.56503 16.9822 4.66301L17.4262 4.79801C17.5883 4.84723 17.761 4.8497 17.9245 4.80512C18.0879 4.76054 18.2355 4.67073 18.3502 4.54601L18.8422 4.01001Z",
    fill: "url(#paint9_radial_434_3634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M18.8422 4.01001C19.0528 3.78083 19.3088 3.59787 19.5938 3.47268C19.8788 3.34749 20.1867 3.28281 20.498 3.28271C20.8092 3.28262 21.1172 3.34712 21.4023 3.47214C21.6873 3.59715 21.9434 3.77996 22.1542 4.00901L22.7322 4.63801C22.8251 4.73881 22.9397 4.81706 23.0675 4.8668C23.1952 4.91654 23.3326 4.93645 23.4692 4.92501L24.5602 4.83301C25.1525 4.78308 25.7405 4.96978 26.1955 5.35227C26.6505 5.73477 26.9355 6.28191 26.9882 6.87401L27.0332 7.37501C27.047 7.52919 27.1004 7.67721 27.1882 7.80473C27.2759 7.93226 27.3951 8.035 27.5342 8.10301L28.2922 8.47301C28.5886 8.61778 28.8496 8.82602 29.0565 9.08296C29.2635 9.3399 29.4113 9.63924 29.4896 9.95973C29.5678 10.2802 29.5746 10.614 29.5094 10.9374C29.4441 11.2608 29.3085 11.5659 29.1122 11.831L28.9122 12.103C28.7981 12.2574 28.7364 12.4442 28.736 12.6362C28.7356 12.8281 28.7967 13.0152 28.9102 13.17L29.1302 13.47C29.3314 13.7443 29.4677 14.0606 29.5289 14.3952C29.5901 14.7298 29.5746 15.0739 29.4835 15.4017C29.3925 15.7294 29.2282 16.0322 29.0031 16.2872C28.7781 16.5423 28.498 16.7429 28.1842 16.874L27.4322 17.188C27.2929 17.2463 27.1706 17.3387 27.0764 17.4566C26.9822 17.5746 26.9192 17.7143 26.8932 17.863L26.6802 19.08C26.5994 19.5397 26.3432 19.9501 25.9655 20.2244C25.5878 20.4987 25.1183 20.6154 24.6562 20.55L23.3842 20.37C23.2485 20.3508 23.1101 20.3629 22.9798 20.4054C22.8495 20.4478 22.7306 20.5195 22.6322 20.615L21.7092 21.509C21.3738 21.8339 20.9251 22.0156 20.4582 22.0156C19.9912 22.0156 19.5426 21.8339 19.2072 21.509L18.2842 20.615C18.1857 20.5197 18.0668 20.4482 17.9364 20.4059C17.8061 20.3636 17.6678 20.3517 17.5322 20.371L16.2362 20.554C15.7782 20.6192 15.3128 20.5054 14.9366 20.2363C14.5604 19.9672 14.3024 19.5635 14.2162 19.109L13.9872 17.902C13.9605 17.762 13.901 17.6304 13.8136 17.5179C13.7261 17.4055 13.6132 17.3153 13.4842 17.255L12.8182 16.945C12.5314 16.8114 12.2761 16.6188 12.0689 16.3798C11.8617 16.1408 11.7073 15.8607 11.6157 15.5579C11.5242 15.2551 11.4976 14.9364 11.5376 14.6227C11.5777 14.3089 11.6835 14.0071 11.8482 13.737L12.1962 13.167C12.2858 13.0198 12.3313 12.8499 12.3272 12.6776C12.3232 12.5053 12.2697 12.3378 12.1732 12.195L11.9072 11.8C11.7122 11.511 11.5871 11.1805 11.5419 10.8348C11.4966 10.4891 11.5324 10.1376 11.6463 9.80807C11.7603 9.47856 11.9494 9.18008 12.1986 8.93623C12.4478 8.69237 12.7503 8.50982 13.0822 8.40301L13.3962 8.30301C13.5657 8.2481 13.7152 8.14409 13.8255 8.00417C13.9359 7.86424 14.0023 7.69469 14.0162 7.51701L14.0862 6.63601C14.1127 6.30081 14.2141 5.97583 14.3829 5.68502C14.5517 5.39421 14.7836 5.14496 15.0615 4.95564C15.3393 4.76632 15.6562 4.64175 15.9886 4.59111C16.321 4.54046 16.6605 4.56503 16.9822 4.66301L17.4262 4.79801C17.5883 4.84723 17.761 4.8497 17.9245 4.80512C18.0879 4.76054 18.2355 4.67073 18.3502 4.54601L18.8422 4.01001Z",
    fill: "url(#paint10_radial_434_3634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M18.8422 4.01001C19.0528 3.78083 19.3088 3.59787 19.5938 3.47268C19.8788 3.34749 20.1867 3.28281 20.498 3.28271C20.8092 3.28262 21.1172 3.34712 21.4023 3.47214C21.6873 3.59715 21.9434 3.77996 22.1542 4.00901L22.7322 4.63801C22.8251 4.73881 22.9397 4.81706 23.0675 4.8668C23.1952 4.91654 23.3326 4.93645 23.4692 4.92501L24.5602 4.83301C25.1525 4.78308 25.7405 4.96978 26.1955 5.35227C26.6505 5.73477 26.9355 6.28191 26.9882 6.87401L27.0332 7.37501C27.047 7.52919 27.1004 7.67721 27.1882 7.80473C27.2759 7.93226 27.3951 8.035 27.5342 8.10301L28.2922 8.47301C28.5886 8.61778 28.8496 8.82602 29.0565 9.08296C29.2635 9.3399 29.4113 9.63924 29.4896 9.95973C29.5678 10.2802 29.5746 10.614 29.5094 10.9374C29.4441 11.2608 29.3085 11.5659 29.1122 11.831L28.9122 12.103C28.7981 12.2574 28.7364 12.4442 28.736 12.6362C28.7356 12.8281 28.7967 13.0152 28.9102 13.17L29.1302 13.47C29.3314 13.7443 29.4677 14.0606 29.5289 14.3952C29.5901 14.7298 29.5746 15.0739 29.4835 15.4017C29.3925 15.7294 29.2282 16.0322 29.0031 16.2872C28.7781 16.5423 28.498 16.7429 28.1842 16.874L27.4322 17.188C27.2929 17.2463 27.1706 17.3387 27.0764 17.4566C26.9822 17.5746 26.9192 17.7143 26.8932 17.863L26.6802 19.08C26.5994 19.5397 26.3432 19.9501 25.9655 20.2244C25.5878 20.4987 25.1183 20.6154 24.6562 20.55L23.3842 20.37C23.2485 20.3508 23.1101 20.3629 22.9798 20.4054C22.8495 20.4478 22.7306 20.5195 22.6322 20.615L21.7092 21.509C21.3738 21.8339 20.9251 22.0156 20.4582 22.0156C19.9912 22.0156 19.5426 21.8339 19.2072 21.509L18.2842 20.615C18.1857 20.5197 18.0668 20.4482 17.9364 20.4059C17.8061 20.3636 17.6678 20.3517 17.5322 20.371L16.2362 20.554C15.7782 20.6192 15.3128 20.5054 14.9366 20.2363C14.5604 19.9672 14.3024 19.5635 14.2162 19.109L13.9872 17.902C13.9605 17.762 13.901 17.6304 13.8136 17.5179C13.7261 17.4055 13.6132 17.3153 13.4842 17.255L12.8182 16.945C12.5314 16.8114 12.2761 16.6188 12.0689 16.3798C11.8617 16.1408 11.7073 15.8607 11.6157 15.5579C11.5242 15.2551 11.4976 14.9364 11.5376 14.6227C11.5777 14.3089 11.6835 14.0071 11.8482 13.737L12.1962 13.167C12.2858 13.0198 12.3313 12.8499 12.3272 12.6776C12.3232 12.5053 12.2697 12.3378 12.1732 12.195L11.9072 11.8C11.7122 11.511 11.5871 11.1805 11.5419 10.8348C11.4966 10.4891 11.5324 10.1376 11.6463 9.80807C11.7603 9.47856 11.9494 9.18008 12.1986 8.93623C12.4478 8.69237 12.7503 8.50982 13.0822 8.40301L13.3962 8.30301C13.5657 8.2481 13.7152 8.14409 13.8255 8.00417C13.9359 7.86424 14.0023 7.69469 14.0162 7.51701L14.0862 6.63601C14.1127 6.30081 14.2141 5.97583 14.3829 5.68502C14.5517 5.39421 14.7836 5.14496 15.0615 4.95564C15.3393 4.76632 15.6562 4.64175 15.9886 4.59111C16.321 4.54046 16.6605 4.56503 16.9822 4.66301L17.4262 4.79801C17.5883 4.84723 17.761 4.8497 17.9245 4.80512C18.0879 4.76054 18.2355 4.67073 18.3502 4.54601L18.8422 4.01001Z",
    fill: "url(#paint11_radial_434_3634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M18.8422 4.01001C19.0528 3.78083 19.3088 3.59787 19.5938 3.47268C19.8788 3.34749 20.1867 3.28281 20.498 3.28271C20.8092 3.28262 21.1172 3.34712 21.4023 3.47214C21.6873 3.59715 21.9434 3.77996 22.1542 4.00901L22.7322 4.63801C22.8251 4.73881 22.9397 4.81706 23.0675 4.8668C23.1952 4.91654 23.3326 4.93645 23.4692 4.92501L24.5602 4.83301C25.1525 4.78308 25.7405 4.96978 26.1955 5.35227C26.6505 5.73477 26.9355 6.28191 26.9882 6.87401L27.0332 7.37501C27.047 7.52919 27.1004 7.67721 27.1882 7.80473C27.2759 7.93226 27.3951 8.035 27.5342 8.10301L28.2922 8.47301C28.5886 8.61778 28.8496 8.82602 29.0565 9.08296C29.2635 9.3399 29.4113 9.63924 29.4896 9.95973C29.5678 10.2802 29.5746 10.614 29.5094 10.9374C29.4441 11.2608 29.3085 11.5659 29.1122 11.831L28.9122 12.103C28.7981 12.2574 28.7364 12.4442 28.736 12.6362C28.7356 12.8281 28.7967 13.0152 28.9102 13.17L29.1302 13.47C29.3314 13.7443 29.4677 14.0606 29.5289 14.3952C29.5901 14.7298 29.5746 15.0739 29.4835 15.4017C29.3925 15.7294 29.2282 16.0322 29.0031 16.2872C28.7781 16.5423 28.498 16.7429 28.1842 16.874L27.4322 17.188C27.2929 17.2463 27.1706 17.3387 27.0764 17.4566C26.9822 17.5746 26.9192 17.7143 26.8932 17.863L26.6802 19.08C26.5994 19.5397 26.3432 19.9501 25.9655 20.2244C25.5878 20.4987 25.1183 20.6154 24.6562 20.55L23.3842 20.37C23.2485 20.3508 23.1101 20.3629 22.9798 20.4054C22.8495 20.4478 22.7306 20.5195 22.6322 20.615L21.7092 21.509C21.3738 21.8339 20.9251 22.0156 20.4582 22.0156C19.9912 22.0156 19.5426 21.8339 19.2072 21.509L18.2842 20.615C18.1857 20.5197 18.0668 20.4482 17.9364 20.4059C17.8061 20.3636 17.6678 20.3517 17.5322 20.371L16.2362 20.554C15.7782 20.6192 15.3128 20.5054 14.9366 20.2363C14.5604 19.9672 14.3024 19.5635 14.2162 19.109L13.9872 17.902C13.9605 17.762 13.901 17.6304 13.8136 17.5179C13.7261 17.4055 13.6132 17.3153 13.4842 17.255L12.8182 16.945C12.5314 16.8114 12.2761 16.6188 12.0689 16.3798C11.8617 16.1408 11.7073 15.8607 11.6157 15.5579C11.5242 15.2551 11.4976 14.9364 11.5376 14.6227C11.5777 14.3089 11.6835 14.0071 11.8482 13.737L12.1962 13.167C12.2858 13.0198 12.3313 12.8499 12.3272 12.6776C12.3232 12.5053 12.2697 12.3378 12.1732 12.195L11.9072 11.8C11.7122 11.511 11.5871 11.1805 11.5419 10.8348C11.4966 10.4891 11.5324 10.1376 11.6463 9.80807C11.7603 9.47856 11.9494 9.18008 12.1986 8.93623C12.4478 8.69237 12.7503 8.50982 13.0822 8.40301L13.3962 8.30301C13.5657 8.2481 13.7152 8.14409 13.8255 8.00417C13.9359 7.86424 14.0023 7.69469 14.0162 7.51701L14.0862 6.63601C14.1127 6.30081 14.2141 5.97583 14.3829 5.68502C14.5517 5.39421 14.7836 5.14496 15.0615 4.95564C15.3393 4.76632 15.6562 4.64175 15.9886 4.59111C16.321 4.54046 16.6605 4.56503 16.9822 4.66301L17.4262 4.79801C17.5883 4.84723 17.761 4.8497 17.9245 4.80512C18.0879 4.76054 18.2355 4.67073 18.3502 4.54601L18.8422 4.01001Z",
    fill: "url(#paint12_radial_434_3634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M18.8422 4.01001C19.0528 3.78083 19.3088 3.59787 19.5938 3.47268C19.8788 3.34749 20.1867 3.28281 20.498 3.28271C20.8092 3.28262 21.1172 3.34712 21.4023 3.47214C21.6873 3.59715 21.9434 3.77996 22.1542 4.00901L22.7322 4.63801C22.8251 4.73881 22.9397 4.81706 23.0675 4.8668C23.1952 4.91654 23.3326 4.93645 23.4692 4.92501L24.5602 4.83301C25.1525 4.78308 25.7405 4.96978 26.1955 5.35227C26.6505 5.73477 26.9355 6.28191 26.9882 6.87401L27.0332 7.37501C27.047 7.52919 27.1004 7.67721 27.1882 7.80473C27.2759 7.93226 27.3951 8.035 27.5342 8.10301L28.2922 8.47301C28.5886 8.61778 28.8496 8.82602 29.0565 9.08296C29.2635 9.3399 29.4113 9.63924 29.4896 9.95973C29.5678 10.2802 29.5746 10.614 29.5094 10.9374C29.4441 11.2608 29.3085 11.5659 29.1122 11.831L28.9122 12.103C28.7981 12.2574 28.7364 12.4442 28.736 12.6362C28.7356 12.8281 28.7967 13.0152 28.9102 13.17L29.1302 13.47C29.3314 13.7443 29.4677 14.0606 29.5289 14.3952C29.5901 14.7298 29.5746 15.0739 29.4835 15.4017C29.3925 15.7294 29.2282 16.0322 29.0031 16.2872C28.7781 16.5423 28.498 16.7429 28.1842 16.874L27.4322 17.188C27.2929 17.2463 27.1706 17.3387 27.0764 17.4566C26.9822 17.5746 26.9192 17.7143 26.8932 17.863L26.6802 19.08C26.5994 19.5397 26.3432 19.9501 25.9655 20.2244C25.5878 20.4987 25.1183 20.6154 24.6562 20.55L23.3842 20.37C23.2485 20.3508 23.1101 20.3629 22.9798 20.4054C22.8495 20.4478 22.7306 20.5195 22.6322 20.615L21.7092 21.509C21.3738 21.8339 20.9251 22.0156 20.4582 22.0156C19.9912 22.0156 19.5426 21.8339 19.2072 21.509L18.2842 20.615C18.1857 20.5197 18.0668 20.4482 17.9364 20.4059C17.8061 20.3636 17.6678 20.3517 17.5322 20.371L16.2362 20.554C15.7782 20.6192 15.3128 20.5054 14.9366 20.2363C14.5604 19.9672 14.3024 19.5635 14.2162 19.109L13.9872 17.902C13.9605 17.762 13.901 17.6304 13.8136 17.5179C13.7261 17.4055 13.6132 17.3153 13.4842 17.255L12.8182 16.945C12.5314 16.8114 12.2761 16.6188 12.0689 16.3798C11.8617 16.1408 11.7073 15.8607 11.6157 15.5579C11.5242 15.2551 11.4976 14.9364 11.5376 14.6227C11.5777 14.3089 11.6835 14.0071 11.8482 13.737L12.1962 13.167C12.2858 13.0198 12.3313 12.8499 12.3272 12.6776C12.3232 12.5053 12.2697 12.3378 12.1732 12.195L11.9072 11.8C11.7122 11.511 11.5871 11.1805 11.5419 10.8348C11.4966 10.4891 11.5324 10.1376 11.6463 9.80807C11.7603 9.47856 11.9494 9.18008 12.1986 8.93623C12.4478 8.69237 12.7503 8.50982 13.0822 8.40301L13.3962 8.30301C13.5657 8.2481 13.7152 8.14409 13.8255 8.00417C13.9359 7.86424 14.0023 7.69469 14.0162 7.51701L14.0862 6.63601C14.1127 6.30081 14.2141 5.97583 14.3829 5.68502C14.5517 5.39421 14.7836 5.14496 15.0615 4.95564C15.3393 4.76632 15.6562 4.64175 15.9886 4.59111C16.321 4.54046 16.6605 4.56503 16.9822 4.66301L17.4262 4.79801C17.5883 4.84723 17.761 4.8497 17.9245 4.80512C18.0879 4.76054 18.2355 4.67073 18.3502 4.54601L18.8422 4.01001Z",
    fill: "url(#paint13_linear_434_3634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M18.8422 4.01001C19.0528 3.78083 19.3088 3.59787 19.5938 3.47268C19.8788 3.34749 20.1867 3.28281 20.498 3.28271C20.8092 3.28262 21.1172 3.34712 21.4023 3.47214C21.6873 3.59715 21.9434 3.77996 22.1542 4.00901L22.7322 4.63801C22.8251 4.73881 22.9397 4.81706 23.0675 4.8668C23.1952 4.91654 23.3326 4.93645 23.4692 4.92501L24.5602 4.83301C25.1525 4.78308 25.7405 4.96978 26.1955 5.35227C26.6505 5.73477 26.9355 6.28191 26.9882 6.87401L27.0332 7.37501C27.047 7.52919 27.1004 7.67721 27.1882 7.80473C27.2759 7.93226 27.3951 8.035 27.5342 8.10301L28.2922 8.47301C28.5886 8.61778 28.8496 8.82602 29.0565 9.08296C29.2635 9.3399 29.4113 9.63924 29.4896 9.95973C29.5678 10.2802 29.5746 10.614 29.5094 10.9374C29.4441 11.2608 29.3085 11.5659 29.1122 11.831L28.9122 12.103C28.7981 12.2574 28.7364 12.4442 28.736 12.6362C28.7356 12.8281 28.7967 13.0152 28.9102 13.17L29.1302 13.47C29.3314 13.7443 29.4677 14.0606 29.5289 14.3952C29.5901 14.7298 29.5746 15.0739 29.4835 15.4017C29.3925 15.7294 29.2282 16.0322 29.0031 16.2872C28.7781 16.5423 28.498 16.7429 28.1842 16.874L27.4322 17.188C27.2929 17.2463 27.1706 17.3387 27.0764 17.4566C26.9822 17.5746 26.9192 17.7143 26.8932 17.863L26.6802 19.08C26.5994 19.5397 26.3432 19.9501 25.9655 20.2244C25.5878 20.4987 25.1183 20.6154 24.6562 20.55L23.3842 20.37C23.2485 20.3508 23.1101 20.3629 22.9798 20.4054C22.8495 20.4478 22.7306 20.5195 22.6322 20.615L21.7092 21.509C21.3738 21.8339 20.9251 22.0156 20.4582 22.0156C19.9912 22.0156 19.5426 21.8339 19.2072 21.509L18.2842 20.615C18.1857 20.5197 18.0668 20.4482 17.9364 20.4059C17.8061 20.3636 17.6678 20.3517 17.5322 20.371L16.2362 20.554C15.7782 20.6192 15.3128 20.5054 14.9366 20.2363C14.5604 19.9672 14.3024 19.5635 14.2162 19.109L13.9872 17.902C13.9605 17.762 13.901 17.6304 13.8136 17.5179C13.7261 17.4055 13.6132 17.3153 13.4842 17.255L12.8182 16.945C12.5314 16.8114 12.2761 16.6188 12.0689 16.3798C11.8617 16.1408 11.7073 15.8607 11.6157 15.5579C11.5242 15.2551 11.4976 14.9364 11.5376 14.6227C11.5777 14.3089 11.6835 14.0071 11.8482 13.737L12.1962 13.167C12.2858 13.0198 12.3313 12.8499 12.3272 12.6776C12.3232 12.5053 12.2697 12.3378 12.1732 12.195L11.9072 11.8C11.7122 11.511 11.5871 11.1805 11.5419 10.8348C11.4966 10.4891 11.5324 10.1376 11.6463 9.80807C11.7603 9.47856 11.9494 9.18008 12.1986 8.93623C12.4478 8.69237 12.7503 8.50982 13.0822 8.40301L13.3962 8.30301C13.5657 8.2481 13.7152 8.14409 13.8255 8.00417C13.9359 7.86424 14.0023 7.69469 14.0162 7.51701L14.0862 6.63601C14.1127 6.30081 14.2141 5.97583 14.3829 5.68502C14.5517 5.39421 14.7836 5.14496 15.0615 4.95564C15.3393 4.76632 15.6562 4.64175 15.9886 4.59111C16.321 4.54046 16.6605 4.56503 16.9822 4.66301L17.4262 4.79801C17.5883 4.84723 17.761 4.8497 17.9245 4.80512C18.0879 4.76054 18.2355 4.67073 18.3502 4.54601L18.8422 4.01001Z",
    fill: "url(#paint14_radial_434_3634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M18.8422 4.01001C19.0528 3.78083 19.3088 3.59787 19.5938 3.47268C19.8788 3.34749 20.1867 3.28281 20.498 3.28271C20.8092 3.28262 21.1172 3.34712 21.4023 3.47214C21.6873 3.59715 21.9434 3.77996 22.1542 4.00901L22.7322 4.63801C22.8251 4.73881 22.9397 4.81706 23.0675 4.8668C23.1952 4.91654 23.3326 4.93645 23.4692 4.92501L24.5602 4.83301C25.1525 4.78308 25.7405 4.96978 26.1955 5.35227C26.6505 5.73477 26.9355 6.28191 26.9882 6.87401L27.0332 7.37501C27.047 7.52919 27.1004 7.67721 27.1882 7.80473C27.2759 7.93226 27.3951 8.035 27.5342 8.10301L28.2922 8.47301C28.5886 8.61778 28.8496 8.82602 29.0565 9.08296C29.2635 9.3399 29.4113 9.63924 29.4896 9.95973C29.5678 10.2802 29.5746 10.614 29.5094 10.9374C29.4441 11.2608 29.3085 11.5659 29.1122 11.831L28.9122 12.103C28.7981 12.2574 28.7364 12.4442 28.736 12.6362C28.7356 12.8281 28.7967 13.0152 28.9102 13.17L29.1302 13.47C29.3314 13.7443 29.4677 14.0606 29.5289 14.3952C29.5901 14.7298 29.5746 15.0739 29.4835 15.4017C29.3925 15.7294 29.2282 16.0322 29.0031 16.2872C28.7781 16.5423 28.498 16.7429 28.1842 16.874L27.4322 17.188C27.2929 17.2463 27.1706 17.3387 27.0764 17.4566C26.9822 17.5746 26.9192 17.7143 26.8932 17.863L26.6802 19.08C26.5994 19.5397 26.3432 19.9501 25.9655 20.2244C25.5878 20.4987 25.1183 20.6154 24.6562 20.55L23.3842 20.37C23.2485 20.3508 23.1101 20.3629 22.9798 20.4054C22.8495 20.4478 22.7306 20.5195 22.6322 20.615L21.7092 21.509C21.3738 21.8339 20.9251 22.0156 20.4582 22.0156C19.9912 22.0156 19.5426 21.8339 19.2072 21.509L18.2842 20.615C18.1857 20.5197 18.0668 20.4482 17.9364 20.4059C17.8061 20.3636 17.6678 20.3517 17.5322 20.371L16.2362 20.554C15.7782 20.6192 15.3128 20.5054 14.9366 20.2363C14.5604 19.9672 14.3024 19.5635 14.2162 19.109L13.9872 17.902C13.9605 17.762 13.901 17.6304 13.8136 17.5179C13.7261 17.4055 13.6132 17.3153 13.4842 17.255L12.8182 16.945C12.5314 16.8114 12.2761 16.6188 12.0689 16.3798C11.8617 16.1408 11.7073 15.8607 11.6157 15.5579C11.5242 15.2551 11.4976 14.9364 11.5376 14.6227C11.5777 14.3089 11.6835 14.0071 11.8482 13.737L12.1962 13.167C12.2858 13.0198 12.3313 12.8499 12.3272 12.6776C12.3232 12.5053 12.2697 12.3378 12.1732 12.195L11.9072 11.8C11.7122 11.511 11.5871 11.1805 11.5419 10.8348C11.4966 10.4891 11.5324 10.1376 11.6463 9.80807C11.7603 9.47856 11.9494 9.18008 12.1986 8.93623C12.4478 8.69237 12.7503 8.50982 13.0822 8.40301L13.3962 8.30301C13.5657 8.2481 13.7152 8.14409 13.8255 8.00417C13.9359 7.86424 14.0023 7.69469 14.0162 7.51701L14.0862 6.63601C14.1127 6.30081 14.2141 5.97583 14.3829 5.68502C14.5517 5.39421 14.7836 5.14496 15.0615 4.95564C15.3393 4.76632 15.6562 4.64175 15.9886 4.59111C16.321 4.54046 16.6605 4.56503 16.9822 4.66301L17.4262 4.79801C17.5883 4.84723 17.761 4.8497 17.9245 4.80512C18.0879 4.76054 18.2355 4.67073 18.3502 4.54601L18.8422 4.01001Z",
    fill: "url(#paint15_radial_434_3634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M18.8422 4.01001C19.0528 3.78083 19.3088 3.59787 19.5938 3.47268C19.8788 3.34749 20.1867 3.28281 20.498 3.28271C20.8092 3.28262 21.1172 3.34712 21.4023 3.47214C21.6873 3.59715 21.9434 3.77996 22.1542 4.00901L22.7322 4.63801C22.8251 4.73881 22.9397 4.81706 23.0675 4.8668C23.1952 4.91654 23.3326 4.93645 23.4692 4.92501L24.5602 4.83301C25.1525 4.78308 25.7405 4.96978 26.1955 5.35227C26.6505 5.73477 26.9355 6.28191 26.9882 6.87401L27.0332 7.37501C27.047 7.52919 27.1004 7.67721 27.1882 7.80473C27.2759 7.93226 27.3951 8.035 27.5342 8.10301L28.2922 8.47301C28.5886 8.61778 28.8496 8.82602 29.0565 9.08296C29.2635 9.3399 29.4113 9.63924 29.4896 9.95973C29.5678 10.2802 29.5746 10.614 29.5094 10.9374C29.4441 11.2608 29.3085 11.5659 29.1122 11.831L28.9122 12.103C28.7981 12.2574 28.7364 12.4442 28.736 12.6362C28.7356 12.8281 28.7967 13.0152 28.9102 13.17L29.1302 13.47C29.3314 13.7443 29.4677 14.0606 29.5289 14.3952C29.5901 14.7298 29.5746 15.0739 29.4835 15.4017C29.3925 15.7294 29.2282 16.0322 29.0031 16.2872C28.7781 16.5423 28.498 16.7429 28.1842 16.874L27.4322 17.188C27.2929 17.2463 27.1706 17.3387 27.0764 17.4566C26.9822 17.5746 26.9192 17.7143 26.8932 17.863L26.6802 19.08C26.5994 19.5397 26.3432 19.9501 25.9655 20.2244C25.5878 20.4987 25.1183 20.6154 24.6562 20.55L23.3842 20.37C23.2485 20.3508 23.1101 20.3629 22.9798 20.4054C22.8495 20.4478 22.7306 20.5195 22.6322 20.615L21.7092 21.509C21.3738 21.8339 20.9251 22.0156 20.4582 22.0156C19.9912 22.0156 19.5426 21.8339 19.2072 21.509L18.2842 20.615C18.1857 20.5197 18.0668 20.4482 17.9364 20.4059C17.8061 20.3636 17.6678 20.3517 17.5322 20.371L16.2362 20.554C15.7782 20.6192 15.3128 20.5054 14.9366 20.2363C14.5604 19.9672 14.3024 19.5635 14.2162 19.109L13.9872 17.902C13.9605 17.762 13.901 17.6304 13.8136 17.5179C13.7261 17.4055 13.6132 17.3153 13.4842 17.255L12.8182 16.945C12.5314 16.8114 12.2761 16.6188 12.0689 16.3798C11.8617 16.1408 11.7073 15.8607 11.6157 15.5579C11.5242 15.2551 11.4976 14.9364 11.5376 14.6227C11.5777 14.3089 11.6835 14.0071 11.8482 13.737L12.1962 13.167C12.2858 13.0198 12.3313 12.8499 12.3272 12.6776C12.3232 12.5053 12.2697 12.3378 12.1732 12.195L11.9072 11.8C11.7122 11.511 11.5871 11.1805 11.5419 10.8348C11.4966 10.4891 11.5324 10.1376 11.6463 9.80807C11.7603 9.47856 11.9494 9.18008 12.1986 8.93623C12.4478 8.69237 12.7503 8.50982 13.0822 8.40301L13.3962 8.30301C13.5657 8.2481 13.7152 8.14409 13.8255 8.00417C13.9359 7.86424 14.0023 7.69469 14.0162 7.51701L14.0862 6.63601C14.1127 6.30081 14.2141 5.97583 14.3829 5.68502C14.5517 5.39421 14.7836 5.14496 15.0615 4.95564C15.3393 4.76632 15.6562 4.64175 15.9886 4.59111C16.321 4.54046 16.6605 4.56503 16.9822 4.66301L17.4262 4.79801C17.5883 4.84723 17.761 4.8497 17.9245 4.80512C18.0879 4.76054 18.2355 4.67073 18.3502 4.54601L18.8422 4.01001Z",
    fill: "url(#paint16_radial_434_3634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M18.8422 4.01001C19.0528 3.78083 19.3088 3.59787 19.5938 3.47268C19.8788 3.34749 20.1867 3.28281 20.498 3.28271C20.8092 3.28262 21.1172 3.34712 21.4023 3.47214C21.6873 3.59715 21.9434 3.77996 22.1542 4.00901L22.7322 4.63801C22.8251 4.73881 22.9397 4.81706 23.0675 4.8668C23.1952 4.91654 23.3326 4.93645 23.4692 4.92501L24.5602 4.83301C25.1525 4.78308 25.7405 4.96978 26.1955 5.35227C26.6505 5.73477 26.9355 6.28191 26.9882 6.87401L27.0332 7.37501C27.047 7.52919 27.1004 7.67721 27.1882 7.80473C27.2759 7.93226 27.3951 8.035 27.5342 8.10301L28.2922 8.47301C28.5886 8.61778 28.8496 8.82602 29.0565 9.08296C29.2635 9.3399 29.4113 9.63924 29.4896 9.95973C29.5678 10.2802 29.5746 10.614 29.5094 10.9374C29.4441 11.2608 29.3085 11.5659 29.1122 11.831L28.9122 12.103C28.7981 12.2574 28.7364 12.4442 28.736 12.6362C28.7356 12.8281 28.7967 13.0152 28.9102 13.17L29.1302 13.47C29.3314 13.7443 29.4677 14.0606 29.5289 14.3952C29.5901 14.7298 29.5746 15.0739 29.4835 15.4017C29.3925 15.7294 29.2282 16.0322 29.0031 16.2872C28.7781 16.5423 28.498 16.7429 28.1842 16.874L27.4322 17.188C27.2929 17.2463 27.1706 17.3387 27.0764 17.4566C26.9822 17.5746 26.9192 17.7143 26.8932 17.863L26.6802 19.08C26.5994 19.5397 26.3432 19.9501 25.9655 20.2244C25.5878 20.4987 25.1183 20.6154 24.6562 20.55L23.3842 20.37C23.2485 20.3508 23.1101 20.3629 22.9798 20.4054C22.8495 20.4478 22.7306 20.5195 22.6322 20.615L21.7092 21.509C21.3738 21.8339 20.9251 22.0156 20.4582 22.0156C19.9912 22.0156 19.5426 21.8339 19.2072 21.509L18.2842 20.615C18.1857 20.5197 18.0668 20.4482 17.9364 20.4059C17.8061 20.3636 17.6678 20.3517 17.5322 20.371L16.2362 20.554C15.7782 20.6192 15.3128 20.5054 14.9366 20.2363C14.5604 19.9672 14.3024 19.5635 14.2162 19.109L13.9872 17.902C13.9605 17.762 13.901 17.6304 13.8136 17.5179C13.7261 17.4055 13.6132 17.3153 13.4842 17.255L12.8182 16.945C12.5314 16.8114 12.2761 16.6188 12.0689 16.3798C11.8617 16.1408 11.7073 15.8607 11.6157 15.5579C11.5242 15.2551 11.4976 14.9364 11.5376 14.6227C11.5777 14.3089 11.6835 14.0071 11.8482 13.737L12.1962 13.167C12.2858 13.0198 12.3313 12.8499 12.3272 12.6776C12.3232 12.5053 12.2697 12.3378 12.1732 12.195L11.9072 11.8C11.7122 11.511 11.5871 11.1805 11.5419 10.8348C11.4966 10.4891 11.5324 10.1376 11.6463 9.80807C11.7603 9.47856 11.9494 9.18008 12.1986 8.93623C12.4478 8.69237 12.7503 8.50982 13.0822 8.40301L13.3962 8.30301C13.5657 8.2481 13.7152 8.14409 13.8255 8.00417C13.9359 7.86424 14.0023 7.69469 14.0162 7.51701L14.0862 6.63601C14.1127 6.30081 14.2141 5.97583 14.3829 5.68502C14.5517 5.39421 14.7836 5.14496 15.0615 4.95564C15.3393 4.76632 15.6562 4.64175 15.9886 4.59111C16.321 4.54046 16.6605 4.56503 16.9822 4.66301L17.4262 4.79801C17.5883 4.84723 17.761 4.8497 17.9245 4.80512C18.0879 4.76054 18.2355 4.67073 18.3502 4.54601L18.8422 4.01001Z",
    fill: "url(#paint17_radial_434_3634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M18.8422 4.01001C19.0528 3.78083 19.3088 3.59787 19.5938 3.47268C19.8788 3.34749 20.1867 3.28281 20.498 3.28271C20.8092 3.28262 21.1172 3.34712 21.4023 3.47214C21.6873 3.59715 21.9434 3.77996 22.1542 4.00901L22.7322 4.63801C22.8251 4.73881 22.9397 4.81706 23.0675 4.8668C23.1952 4.91654 23.3326 4.93645 23.4692 4.92501L24.5602 4.83301C25.1525 4.78308 25.7405 4.96978 26.1955 5.35227C26.6505 5.73477 26.9355 6.28191 26.9882 6.87401L27.0332 7.37501C27.047 7.52919 27.1004 7.67721 27.1882 7.80473C27.2759 7.93226 27.3951 8.035 27.5342 8.10301L28.2922 8.47301C28.5886 8.61778 28.8496 8.82602 29.0565 9.08296C29.2635 9.3399 29.4113 9.63924 29.4896 9.95973C29.5678 10.2802 29.5746 10.614 29.5094 10.9374C29.4441 11.2608 29.3085 11.5659 29.1122 11.831L28.9122 12.103C28.7981 12.2574 28.7364 12.4442 28.736 12.6362C28.7356 12.8281 28.7967 13.0152 28.9102 13.17L29.1302 13.47C29.3314 13.7443 29.4677 14.0606 29.5289 14.3952C29.5901 14.7298 29.5746 15.0739 29.4835 15.4017C29.3925 15.7294 29.2282 16.0322 29.0031 16.2872C28.7781 16.5423 28.498 16.7429 28.1842 16.874L27.4322 17.188C27.2929 17.2463 27.1706 17.3387 27.0764 17.4566C26.9822 17.5746 26.9192 17.7143 26.8932 17.863L26.6802 19.08C26.5994 19.5397 26.3432 19.9501 25.9655 20.2244C25.5878 20.4987 25.1183 20.6154 24.6562 20.55L23.3842 20.37C23.2485 20.3508 23.1101 20.3629 22.9798 20.4054C22.8495 20.4478 22.7306 20.5195 22.6322 20.615L21.7092 21.509C21.3738 21.8339 20.9251 22.0156 20.4582 22.0156C19.9912 22.0156 19.5426 21.8339 19.2072 21.509L18.2842 20.615C18.1857 20.5197 18.0668 20.4482 17.9364 20.4059C17.8061 20.3636 17.6678 20.3517 17.5322 20.371L16.2362 20.554C15.7782 20.6192 15.3128 20.5054 14.9366 20.2363C14.5604 19.9672 14.3024 19.5635 14.2162 19.109L13.9872 17.902C13.9605 17.762 13.901 17.6304 13.8136 17.5179C13.7261 17.4055 13.6132 17.3153 13.4842 17.255L12.8182 16.945C12.5314 16.8114 12.2761 16.6188 12.0689 16.3798C11.8617 16.1408 11.7073 15.8607 11.6157 15.5579C11.5242 15.2551 11.4976 14.9364 11.5376 14.6227C11.5777 14.3089 11.6835 14.0071 11.8482 13.737L12.1962 13.167C12.2858 13.0198 12.3313 12.8499 12.3272 12.6776C12.3232 12.5053 12.2697 12.3378 12.1732 12.195L11.9072 11.8C11.7122 11.511 11.5871 11.1805 11.5419 10.8348C11.4966 10.4891 11.5324 10.1376 11.6463 9.80807C11.7603 9.47856 11.9494 9.18008 12.1986 8.93623C12.4478 8.69237 12.7503 8.50982 13.0822 8.40301L13.3962 8.30301C13.5657 8.2481 13.7152 8.14409 13.8255 8.00417C13.9359 7.86424 14.0023 7.69469 14.0162 7.51701L14.0862 6.63601C14.1127 6.30081 14.2141 5.97583 14.3829 5.68502C14.5517 5.39421 14.7836 5.14496 15.0615 4.95564C15.3393 4.76632 15.6562 4.64175 15.9886 4.59111C16.321 4.54046 16.6605 4.56503 16.9822 4.66301L17.4262 4.79801C17.5883 4.84723 17.761 4.8497 17.9245 4.80512C18.0879 4.76054 18.2355 4.67073 18.3502 4.54601L18.8422 4.01001Z",
    fill: "url(#paint18_radial_434_3634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M18.8422 4.01001C19.0528 3.78083 19.3088 3.59787 19.5938 3.47268C19.8788 3.34749 20.1867 3.28281 20.498 3.28271C20.8092 3.28262 21.1172 3.34712 21.4023 3.47214C21.6873 3.59715 21.9434 3.77996 22.1542 4.00901L22.7322 4.63801C22.8251 4.73881 22.9397 4.81706 23.0675 4.8668C23.1952 4.91654 23.3326 4.93645 23.4692 4.92501L24.5602 4.83301C25.1525 4.78308 25.7405 4.96978 26.1955 5.35227C26.6505 5.73477 26.9355 6.28191 26.9882 6.87401L27.0332 7.37501C27.047 7.52919 27.1004 7.67721 27.1882 7.80473C27.2759 7.93226 27.3951 8.035 27.5342 8.10301L28.2922 8.47301C28.5886 8.61778 28.8496 8.82602 29.0565 9.08296C29.2635 9.3399 29.4113 9.63924 29.4896 9.95973C29.5678 10.2802 29.5746 10.614 29.5094 10.9374C29.4441 11.2608 29.3085 11.5659 29.1122 11.831L28.9122 12.103C28.7981 12.2574 28.7364 12.4442 28.736 12.6362C28.7356 12.8281 28.7967 13.0152 28.9102 13.17L29.1302 13.47C29.3314 13.7443 29.4677 14.0606 29.5289 14.3952C29.5901 14.7298 29.5746 15.0739 29.4835 15.4017C29.3925 15.7294 29.2282 16.0322 29.0031 16.2872C28.7781 16.5423 28.498 16.7429 28.1842 16.874L27.4322 17.188C27.2929 17.2463 27.1706 17.3387 27.0764 17.4566C26.9822 17.5746 26.9192 17.7143 26.8932 17.863L26.6802 19.08C26.5994 19.5397 26.3432 19.9501 25.9655 20.2244C25.5878 20.4987 25.1183 20.6154 24.6562 20.55L23.3842 20.37C23.2485 20.3508 23.1101 20.3629 22.9798 20.4054C22.8495 20.4478 22.7306 20.5195 22.6322 20.615L21.7092 21.509C21.3738 21.8339 20.9251 22.0156 20.4582 22.0156C19.9912 22.0156 19.5426 21.8339 19.2072 21.509L18.2842 20.615C18.1857 20.5197 18.0668 20.4482 17.9364 20.4059C17.8061 20.3636 17.6678 20.3517 17.5322 20.371L16.2362 20.554C15.7782 20.6192 15.3128 20.5054 14.9366 20.2363C14.5604 19.9672 14.3024 19.5635 14.2162 19.109L13.9872 17.902C13.9605 17.762 13.901 17.6304 13.8136 17.5179C13.7261 17.4055 13.6132 17.3153 13.4842 17.255L12.8182 16.945C12.5314 16.8114 12.2761 16.6188 12.0689 16.3798C11.8617 16.1408 11.7073 15.8607 11.6157 15.5579C11.5242 15.2551 11.4976 14.9364 11.5376 14.6227C11.5777 14.3089 11.6835 14.0071 11.8482 13.737L12.1962 13.167C12.2858 13.0198 12.3313 12.8499 12.3272 12.6776C12.3232 12.5053 12.2697 12.3378 12.1732 12.195L11.9072 11.8C11.7122 11.511 11.5871 11.1805 11.5419 10.8348C11.4966 10.4891 11.5324 10.1376 11.6463 9.80807C11.7603 9.47856 11.9494 9.18008 12.1986 8.93623C12.4478 8.69237 12.7503 8.50982 13.0822 8.40301L13.3962 8.30301C13.5657 8.2481 13.7152 8.14409 13.8255 8.00417C13.9359 7.86424 14.0023 7.69469 14.0162 7.51701L14.0862 6.63601C14.1127 6.30081 14.2141 5.97583 14.3829 5.68502C14.5517 5.39421 14.7836 5.14496 15.0615 4.95564C15.3393 4.76632 15.6562 4.64175 15.9886 4.59111C16.321 4.54046 16.6605 4.56503 16.9822 4.66301L17.4262 4.79801C17.5883 4.84723 17.761 4.8497 17.9245 4.80512C18.0879 4.76054 18.2355 4.67073 18.3502 4.54601L18.8422 4.01001Z",
    fill: "url(#paint19_radial_434_3634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M18.8422 4.01001C19.0528 3.78083 19.3088 3.59787 19.5938 3.47268C19.8788 3.34749 20.1867 3.28281 20.498 3.28271C20.8092 3.28262 21.1172 3.34712 21.4023 3.47214C21.6873 3.59715 21.9434 3.77996 22.1542 4.00901L22.7322 4.63801C22.8251 4.73881 22.9397 4.81706 23.0675 4.8668C23.1952 4.91654 23.3326 4.93645 23.4692 4.92501L24.5602 4.83301C25.1525 4.78308 25.7405 4.96978 26.1955 5.35227C26.6505 5.73477 26.9355 6.28191 26.9882 6.87401L27.0332 7.37501C27.047 7.52919 27.1004 7.67721 27.1882 7.80473C27.2759 7.93226 27.3951 8.035 27.5342 8.10301L28.2922 8.47301C28.5886 8.61778 28.8496 8.82602 29.0565 9.08296C29.2635 9.3399 29.4113 9.63924 29.4896 9.95973C29.5678 10.2802 29.5746 10.614 29.5094 10.9374C29.4441 11.2608 29.3085 11.5659 29.1122 11.831L28.9122 12.103C28.7981 12.2574 28.7364 12.4442 28.736 12.6362C28.7356 12.8281 28.7967 13.0152 28.9102 13.17L29.1302 13.47C29.3314 13.7443 29.4677 14.0606 29.5289 14.3952C29.5901 14.7298 29.5746 15.0739 29.4835 15.4017C29.3925 15.7294 29.2282 16.0322 29.0031 16.2872C28.7781 16.5423 28.498 16.7429 28.1842 16.874L27.4322 17.188C27.2929 17.2463 27.1706 17.3387 27.0764 17.4566C26.9822 17.5746 26.9192 17.7143 26.8932 17.863L26.6802 19.08C26.5994 19.5397 26.3432 19.9501 25.9655 20.2244C25.5878 20.4987 25.1183 20.6154 24.6562 20.55L23.3842 20.37C23.2485 20.3508 23.1101 20.3629 22.9798 20.4054C22.8495 20.4478 22.7306 20.5195 22.6322 20.615L21.7092 21.509C21.3738 21.8339 20.9251 22.0156 20.4582 22.0156C19.9912 22.0156 19.5426 21.8339 19.2072 21.509L18.2842 20.615C18.1857 20.5197 18.0668 20.4482 17.9364 20.4059C17.8061 20.3636 17.6678 20.3517 17.5322 20.371L16.2362 20.554C15.7782 20.6192 15.3128 20.5054 14.9366 20.2363C14.5604 19.9672 14.3024 19.5635 14.2162 19.109L13.9872 17.902C13.9605 17.762 13.901 17.6304 13.8136 17.5179C13.7261 17.4055 13.6132 17.3153 13.4842 17.255L12.8182 16.945C12.5314 16.8114 12.2761 16.6188 12.0689 16.3798C11.8617 16.1408 11.7073 15.8607 11.6157 15.5579C11.5242 15.2551 11.4976 14.9364 11.5376 14.6227C11.5777 14.3089 11.6835 14.0071 11.8482 13.737L12.1962 13.167C12.2858 13.0198 12.3313 12.8499 12.3272 12.6776C12.3232 12.5053 12.2697 12.3378 12.1732 12.195L11.9072 11.8C11.7122 11.511 11.5871 11.1805 11.5419 10.8348C11.4966 10.4891 11.5324 10.1376 11.6463 9.80807C11.7603 9.47856 11.9494 9.18008 12.1986 8.93623C12.4478 8.69237 12.7503 8.50982 13.0822 8.40301L13.3962 8.30301C13.5657 8.2481 13.7152 8.14409 13.8255 8.00417C13.9359 7.86424 14.0023 7.69469 14.0162 7.51701L14.0862 6.63601C14.1127 6.30081 14.2141 5.97583 14.3829 5.68502C14.5517 5.39421 14.7836 5.14496 15.0615 4.95564C15.3393 4.76632 15.6562 4.64175 15.9886 4.59111C16.321 4.54046 16.6605 4.56503 16.9822 4.66301L17.4262 4.79801C17.5883 4.84723 17.761 4.8497 17.9245 4.80512C18.0879 4.76054 18.2355 4.67073 18.3502 4.54601L18.8422 4.01001Z",
    fill: "url(#paint20_radial_434_3634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M18.8422 4.01001C19.0528 3.78083 19.3088 3.59787 19.5938 3.47268C19.8788 3.34749 20.1867 3.28281 20.498 3.28271C20.8092 3.28262 21.1172 3.34712 21.4023 3.47214C21.6873 3.59715 21.9434 3.77996 22.1542 4.00901L22.7322 4.63801C22.8251 4.73881 22.9397 4.81706 23.0675 4.8668C23.1952 4.91654 23.3326 4.93645 23.4692 4.92501L24.5602 4.83301C25.1525 4.78308 25.7405 4.96978 26.1955 5.35227C26.6505 5.73477 26.9355 6.28191 26.9882 6.87401L27.0332 7.37501C27.047 7.52919 27.1004 7.67721 27.1882 7.80473C27.2759 7.93226 27.3951 8.035 27.5342 8.10301L28.2922 8.47301C28.5886 8.61778 28.8496 8.82602 29.0565 9.08296C29.2635 9.3399 29.4113 9.63924 29.4896 9.95973C29.5678 10.2802 29.5746 10.614 29.5094 10.9374C29.4441 11.2608 29.3085 11.5659 29.1122 11.831L28.9122 12.103C28.7981 12.2574 28.7364 12.4442 28.736 12.6362C28.7356 12.8281 28.7967 13.0152 28.9102 13.17L29.1302 13.47C29.3314 13.7443 29.4677 14.0606 29.5289 14.3952C29.5901 14.7298 29.5746 15.0739 29.4835 15.4017C29.3925 15.7294 29.2282 16.0322 29.0031 16.2872C28.7781 16.5423 28.498 16.7429 28.1842 16.874L27.4322 17.188C27.2929 17.2463 27.1706 17.3387 27.0764 17.4566C26.9822 17.5746 26.9192 17.7143 26.8932 17.863L26.6802 19.08C26.5994 19.5397 26.3432 19.9501 25.9655 20.2244C25.5878 20.4987 25.1183 20.6154 24.6562 20.55L23.3842 20.37C23.2485 20.3508 23.1101 20.3629 22.9798 20.4054C22.8495 20.4478 22.7306 20.5195 22.6322 20.615L21.7092 21.509C21.3738 21.8339 20.9251 22.0156 20.4582 22.0156C19.9912 22.0156 19.5426 21.8339 19.2072 21.509L18.2842 20.615C18.1857 20.5197 18.0668 20.4482 17.9364 20.4059C17.8061 20.3636 17.6678 20.3517 17.5322 20.371L16.2362 20.554C15.7782 20.6192 15.3128 20.5054 14.9366 20.2363C14.5604 19.9672 14.3024 19.5635 14.2162 19.109L13.9872 17.902C13.9605 17.762 13.901 17.6304 13.8136 17.5179C13.7261 17.4055 13.6132 17.3153 13.4842 17.255L12.8182 16.945C12.5314 16.8114 12.2761 16.6188 12.0689 16.3798C11.8617 16.1408 11.7073 15.8607 11.6157 15.5579C11.5242 15.2551 11.4976 14.9364 11.5376 14.6227C11.5777 14.3089 11.6835 14.0071 11.8482 13.737L12.1962 13.167C12.2858 13.0198 12.3313 12.8499 12.3272 12.6776C12.3232 12.5053 12.2697 12.3378 12.1732 12.195L11.9072 11.8C11.7122 11.511 11.5871 11.1805 11.5419 10.8348C11.4966 10.4891 11.5324 10.1376 11.6463 9.80807C11.7603 9.47856 11.9494 9.18008 12.1986 8.93623C12.4478 8.69237 12.7503 8.50982 13.0822 8.40301L13.3962 8.30301C13.5657 8.2481 13.7152 8.14409 13.8255 8.00417C13.9359 7.86424 14.0023 7.69469 14.0162 7.51701L14.0862 6.63601C14.1127 6.30081 14.2141 5.97583 14.3829 5.68502C14.5517 5.39421 14.7836 5.14496 15.0615 4.95564C15.3393 4.76632 15.6562 4.64175 15.9886 4.59111C16.321 4.54046 16.6605 4.56503 16.9822 4.66301L17.4262 4.79801C17.5883 4.84723 17.761 4.8497 17.9245 4.80512C18.0879 4.76054 18.2355 4.67073 18.3502 4.54601L18.8422 4.01001Z",
    fill: "url(#paint21_radial_434_3634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M18.8422 4.01001C19.0528 3.78083 19.3088 3.59787 19.5938 3.47268C19.8788 3.34749 20.1867 3.28281 20.498 3.28271C20.8092 3.28262 21.1172 3.34712 21.4023 3.47214C21.6873 3.59715 21.9434 3.77996 22.1542 4.00901L22.7322 4.63801C22.8251 4.73881 22.9397 4.81706 23.0675 4.8668C23.1952 4.91654 23.3326 4.93645 23.4692 4.92501L24.5602 4.83301C25.1525 4.78308 25.7405 4.96978 26.1955 5.35227C26.6505 5.73477 26.9355 6.28191 26.9882 6.87401L27.0332 7.37501C27.047 7.52919 27.1004 7.67721 27.1882 7.80473C27.2759 7.93226 27.3951 8.035 27.5342 8.10301L28.2922 8.47301C28.5886 8.61778 28.8496 8.82602 29.0565 9.08296C29.2635 9.3399 29.4113 9.63924 29.4896 9.95973C29.5678 10.2802 29.5746 10.614 29.5094 10.9374C29.4441 11.2608 29.3085 11.5659 29.1122 11.831L28.9122 12.103C28.7981 12.2574 28.7364 12.4442 28.736 12.6362C28.7356 12.8281 28.7967 13.0152 28.9102 13.17L29.1302 13.47C29.3314 13.7443 29.4677 14.0606 29.5289 14.3952C29.5901 14.7298 29.5746 15.0739 29.4835 15.4017C29.3925 15.7294 29.2282 16.0322 29.0031 16.2872C28.7781 16.5423 28.498 16.7429 28.1842 16.874L27.4322 17.188C27.2929 17.2463 27.1706 17.3387 27.0764 17.4566C26.9822 17.5746 26.9192 17.7143 26.8932 17.863L26.6802 19.08C26.5994 19.5397 26.3432 19.9501 25.9655 20.2244C25.5878 20.4987 25.1183 20.6154 24.6562 20.55L23.3842 20.37C23.2485 20.3508 23.1101 20.3629 22.9798 20.4054C22.8495 20.4478 22.7306 20.5195 22.6322 20.615L21.7092 21.509C21.3738 21.8339 20.9251 22.0156 20.4582 22.0156C19.9912 22.0156 19.5426 21.8339 19.2072 21.509L18.2842 20.615C18.1857 20.5197 18.0668 20.4482 17.9364 20.4059C17.8061 20.3636 17.6678 20.3517 17.5322 20.371L16.2362 20.554C15.7782 20.6192 15.3128 20.5054 14.9366 20.2363C14.5604 19.9672 14.3024 19.5635 14.2162 19.109L13.9872 17.902C13.9605 17.762 13.901 17.6304 13.8136 17.5179C13.7261 17.4055 13.6132 17.3153 13.4842 17.255L12.8182 16.945C12.5314 16.8114 12.2761 16.6188 12.0689 16.3798C11.8617 16.1408 11.7073 15.8607 11.6157 15.5579C11.5242 15.2551 11.4976 14.9364 11.5376 14.6227C11.5777 14.3089 11.6835 14.0071 11.8482 13.737L12.1962 13.167C12.2858 13.0198 12.3313 12.8499 12.3272 12.6776C12.3232 12.5053 12.2697 12.3378 12.1732 12.195L11.9072 11.8C11.7122 11.511 11.5871 11.1805 11.5419 10.8348C11.4966 10.4891 11.5324 10.1376 11.6463 9.80807C11.7603 9.47856 11.9494 9.18008 12.1986 8.93623C12.4478 8.69237 12.7503 8.50982 13.0822 8.40301L13.3962 8.30301C13.5657 8.2481 13.7152 8.14409 13.8255 8.00417C13.9359 7.86424 14.0023 7.69469 14.0162 7.51701L14.0862 6.63601C14.1127 6.30081 14.2141 5.97583 14.3829 5.68502C14.5517 5.39421 14.7836 5.14496 15.0615 4.95564C15.3393 4.76632 15.6562 4.64175 15.9886 4.59111C16.321 4.54046 16.6605 4.56503 16.9822 4.66301L17.4262 4.79801C17.5883 4.84723 17.761 4.8497 17.9245 4.80512C18.0879 4.76054 18.2355 4.67073 18.3502 4.54601L18.8422 4.01001Z",
    fill: "url(#paint22_radial_434_3634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M18.8422 4.01001C19.0528 3.78083 19.3088 3.59787 19.5938 3.47268C19.8788 3.34749 20.1867 3.28281 20.498 3.28271C20.8092 3.28262 21.1172 3.34712 21.4023 3.47214C21.6873 3.59715 21.9434 3.77996 22.1542 4.00901L22.7322 4.63801C22.8251 4.73881 22.9397 4.81706 23.0675 4.8668C23.1952 4.91654 23.3326 4.93645 23.4692 4.92501L24.5602 4.83301C25.1525 4.78308 25.7405 4.96978 26.1955 5.35227C26.6505 5.73477 26.9355 6.28191 26.9882 6.87401L27.0332 7.37501C27.047 7.52919 27.1004 7.67721 27.1882 7.80473C27.2759 7.93226 27.3951 8.035 27.5342 8.10301L28.2922 8.47301C28.5886 8.61778 28.8496 8.82602 29.0565 9.08296C29.2635 9.3399 29.4113 9.63924 29.4896 9.95973C29.5678 10.2802 29.5746 10.614 29.5094 10.9374C29.4441 11.2608 29.3085 11.5659 29.1122 11.831L28.9122 12.103C28.7981 12.2574 28.7364 12.4442 28.736 12.6362C28.7356 12.8281 28.7967 13.0152 28.9102 13.17L29.1302 13.47C29.3314 13.7443 29.4677 14.0606 29.5289 14.3952C29.5901 14.7298 29.5746 15.0739 29.4835 15.4017C29.3925 15.7294 29.2282 16.0322 29.0031 16.2872C28.7781 16.5423 28.498 16.7429 28.1842 16.874L27.4322 17.188C27.2929 17.2463 27.1706 17.3387 27.0764 17.4566C26.9822 17.5746 26.9192 17.7143 26.8932 17.863L26.6802 19.08C26.5994 19.5397 26.3432 19.9501 25.9655 20.2244C25.5878 20.4987 25.1183 20.6154 24.6562 20.55L23.3842 20.37C23.2485 20.3508 23.1101 20.3629 22.9798 20.4054C22.8495 20.4478 22.7306 20.5195 22.6322 20.615L21.7092 21.509C21.3738 21.8339 20.9251 22.0156 20.4582 22.0156C19.9912 22.0156 19.5426 21.8339 19.2072 21.509L18.2842 20.615C18.1857 20.5197 18.0668 20.4482 17.9364 20.4059C17.8061 20.3636 17.6678 20.3517 17.5322 20.371L16.2362 20.554C15.7782 20.6192 15.3128 20.5054 14.9366 20.2363C14.5604 19.9672 14.3024 19.5635 14.2162 19.109L13.9872 17.902C13.9605 17.762 13.901 17.6304 13.8136 17.5179C13.7261 17.4055 13.6132 17.3153 13.4842 17.255L12.8182 16.945C12.5314 16.8114 12.2761 16.6188 12.0689 16.3798C11.8617 16.1408 11.7073 15.8607 11.6157 15.5579C11.5242 15.2551 11.4976 14.9364 11.5376 14.6227C11.5777 14.3089 11.6835 14.0071 11.8482 13.737L12.1962 13.167C12.2858 13.0198 12.3313 12.8499 12.3272 12.6776C12.3232 12.5053 12.2697 12.3378 12.1732 12.195L11.9072 11.8C11.7122 11.511 11.5871 11.1805 11.5419 10.8348C11.4966 10.4891 11.5324 10.1376 11.6463 9.80807C11.7603 9.47856 11.9494 9.18008 12.1986 8.93623C12.4478 8.69237 12.7503 8.50982 13.0822 8.40301L13.3962 8.30301C13.5657 8.2481 13.7152 8.14409 13.8255 8.00417C13.9359 7.86424 14.0023 7.69469 14.0162 7.51701L14.0862 6.63601C14.1127 6.30081 14.2141 5.97583 14.3829 5.68502C14.5517 5.39421 14.7836 5.14496 15.0615 4.95564C15.3393 4.76632 15.6562 4.64175 15.9886 4.59111C16.321 4.54046 16.6605 4.56503 16.9822 4.66301L17.4262 4.79801C17.5883 4.84723 17.761 4.8497 17.9245 4.80512C18.0879 4.76054 18.2355 4.67073 18.3502 4.54601L18.8422 4.01001Z",
    fill: "url(#paint23_radial_434_3634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M18.8422 4.01001C19.0528 3.78083 19.3088 3.59787 19.5938 3.47268C19.8788 3.34749 20.1867 3.28281 20.498 3.28271C20.8092 3.28262 21.1172 3.34712 21.4023 3.47214C21.6873 3.59715 21.9434 3.77996 22.1542 4.00901L22.7322 4.63801C22.8251 4.73881 22.9397 4.81706 23.0675 4.8668C23.1952 4.91654 23.3326 4.93645 23.4692 4.92501L24.5602 4.83301C25.1525 4.78308 25.7405 4.96978 26.1955 5.35227C26.6505 5.73477 26.9355 6.28191 26.9882 6.87401L27.0332 7.37501C27.047 7.52919 27.1004 7.67721 27.1882 7.80473C27.2759 7.93226 27.3951 8.035 27.5342 8.10301L28.2922 8.47301C28.5886 8.61778 28.8496 8.82602 29.0565 9.08296C29.2635 9.3399 29.4113 9.63924 29.4896 9.95973C29.5678 10.2802 29.5746 10.614 29.5094 10.9374C29.4441 11.2608 29.3085 11.5659 29.1122 11.831L28.9122 12.103C28.7981 12.2574 28.7364 12.4442 28.736 12.6362C28.7356 12.8281 28.7967 13.0152 28.9102 13.17L29.1302 13.47C29.3314 13.7443 29.4677 14.0606 29.5289 14.3952C29.5901 14.7298 29.5746 15.0739 29.4835 15.4017C29.3925 15.7294 29.2282 16.0322 29.0031 16.2872C28.7781 16.5423 28.498 16.7429 28.1842 16.874L27.4322 17.188C27.2929 17.2463 27.1706 17.3387 27.0764 17.4566C26.9822 17.5746 26.9192 17.7143 26.8932 17.863L26.6802 19.08C26.5994 19.5397 26.3432 19.9501 25.9655 20.2244C25.5878 20.4987 25.1183 20.6154 24.6562 20.55L23.3842 20.37C23.2485 20.3508 23.1101 20.3629 22.9798 20.4054C22.8495 20.4478 22.7306 20.5195 22.6322 20.615L21.7092 21.509C21.3738 21.8339 20.9251 22.0156 20.4582 22.0156C19.9912 22.0156 19.5426 21.8339 19.2072 21.509L18.2842 20.615C18.1857 20.5197 18.0668 20.4482 17.9364 20.4059C17.8061 20.3636 17.6678 20.3517 17.5322 20.371L16.2362 20.554C15.7782 20.6192 15.3128 20.5054 14.9366 20.2363C14.5604 19.9672 14.3024 19.5635 14.2162 19.109L13.9872 17.902C13.9605 17.762 13.901 17.6304 13.8136 17.5179C13.7261 17.4055 13.6132 17.3153 13.4842 17.255L12.8182 16.945C12.5314 16.8114 12.2761 16.6188 12.0689 16.3798C11.8617 16.1408 11.7073 15.8607 11.6157 15.5579C11.5242 15.2551 11.4976 14.9364 11.5376 14.6227C11.5777 14.3089 11.6835 14.0071 11.8482 13.737L12.1962 13.167C12.2858 13.0198 12.3313 12.8499 12.3272 12.6776C12.3232 12.5053 12.2697 12.3378 12.1732 12.195L11.9072 11.8C11.7122 11.511 11.5871 11.1805 11.5419 10.8348C11.4966 10.4891 11.5324 10.1376 11.6463 9.80807C11.7603 9.47856 11.9494 9.18008 12.1986 8.93623C12.4478 8.69237 12.7503 8.50982 13.0822 8.40301L13.3962 8.30301C13.5657 8.2481 13.7152 8.14409 13.8255 8.00417C13.9359 7.86424 14.0023 7.69469 14.0162 7.51701L14.0862 6.63601C14.1127 6.30081 14.2141 5.97583 14.3829 5.68502C14.5517 5.39421 14.7836 5.14496 15.0615 4.95564C15.3393 4.76632 15.6562 4.64175 15.9886 4.59111C16.321 4.54046 16.6605 4.56503 16.9822 4.66301L17.4262 4.79801C17.5883 4.84723 17.761 4.8497 17.9245 4.80512C18.0879 4.76054 18.2355 4.67073 18.3502 4.54601L18.8422 4.01001Z",
    fill: "url(#paint24_radial_434_3634)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    filter: "url(#filter2_d_434_3634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M20.529 19.7961C21.4797 19.8073 22.4232 19.6297 23.3049 19.2736C24.1865 18.9176 24.9887 18.3901 25.6649 17.7217C26.3412 17.0534 26.8781 16.2575 27.2446 15.3801C27.611 14.5027 27.7997 13.5614 27.7997 12.6106C27.7997 11.6597 27.611 10.7184 27.2446 9.84103C26.8781 8.96367 26.3412 8.16776 25.6649 7.49941C24.9887 6.83106 24.1865 6.30357 23.3049 5.94749C22.4232 5.59142 21.4797 5.41384 20.529 5.42506C18.6379 5.44737 16.8319 6.21423 15.5026 7.55935C14.1732 8.90447 13.4277 10.7194 13.4277 12.6106C13.4277 14.5017 14.1732 16.3167 15.5026 17.6618C16.8319 19.0069 18.6379 19.7738 20.529 19.7961Z",
    fill: "url(#paint25_radial_434_3634)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    filter: "url(#filter3_i_434_3634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M18.5 30H26.5C27.229 30 27.912 29.805 28.5 29.465V17.25C28.5 16.56 27.94 16 27.25 16H19.75C19.06 16 18.5 16.56 18.5 17.25V30Z",
    fill: "#4C3563"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M18.5 30H26.5C27.229 30 27.912 29.805 28.5 29.465V17.25C28.5 16.56 27.94 16 27.25 16H19.75C19.06 16 18.5 16.56 18.5 17.25V30Z",
    fill: "url(#paint26_linear_434_3634)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M18.5 30H26.5C27.229 30 27.912 29.805 28.5 29.465V17.25C28.5 16.56 27.94 16 27.25 16H19.75C19.06 16 18.5 16.56 18.5 17.25V30Z",
    fill: "url(#paint27_linear_434_3634)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    filter: "url(#filter4_ii_434_3634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M6.5 30H13.5V7.25C13.5 6.56 12.94 6 12.25 6H10.75C10.06 6 9.5 6.56 9.5 7.25V8H5.75C5.06 8 4.5 8.56 4.5 9.25V29.465C5.088 29.805 5.771 30 6.5 30Z",
    fill: "#533968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M6.5 30H13.5V7.25C13.5 6.56 12.94 6 12.25 6H10.75C10.06 6 9.5 6.56 9.5 7.25V8H5.75C5.06 8 4.5 8.56 4.5 9.25V29.465C5.088 29.805 5.771 30 6.5 30Z",
    fill: "url(#paint28_linear_434_3634)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    filter: "url(#filter5_ii_434_3634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M23.5 30H26.5C27.5609 30 28.5783 29.5786 29.3284 28.8284C30.0786 28.0783 30.5 27.0609 30.5 26V19H24.75C24.06 19 23.5 19.56 23.5 20.25V30Z",
    fill: "url(#paint29_linear_434_3634)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    filter: "url(#filter6_i_434_3634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M2.5 14V26C2.5 27.0609 2.92143 28.0783 3.67157 28.8284C4.42172 29.5786 5.43913 30 6.5 30H7.5V15.25C7.5 14.56 6.94 14 6.25 14H2.5Z",
    fill: "url(#paint30_linear_434_3634)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M2.5 14V26C2.5 27.0609 2.92143 28.0783 3.67157 28.8284C4.42172 29.5786 5.43913 30 6.5 30H7.5V15.25C7.5 14.56 6.94 14 6.25 14H2.5Z",
    fill: "url(#paint31_linear_434_3634)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    filter: "url(#filter7_ii_434_3634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M9.5 30H21.5V24.25C21.5 23.56 20.94 23 20.25 23H19.5V12.25C19.5 11.56 18.94 11 18.25 11H10.75C10.06 11 9.5 11.56 9.5 12.25V30Z",
    fill: "url(#paint32_linear_434_3634)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M9.5 30H21.5V24.25C21.5 23.56 20.94 23 20.25 23H19.5V12.25C19.5 11.56 18.94 11 18.25 11H10.75C10.06 11 9.5 11.56 9.5 12.25V30Z",
    fill: "url(#paint33_linear_434_3634)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    filter: "url(#filter8_i_434_3634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5 25H25.5C25.2348 25 24.9804 25.1054 24.7929 25.2929C24.6054 25.4804 24.5 25.7348 24.5 26C24.5 26.2652 24.6054 26.5196 24.7929 26.7071C24.9804 26.8946 25.2348 27 25.5 27H30.374C30.4579 26.6733 30.5002 26.3373 30.5 26V25Z",
    fill: "url(#paint34_linear_434_3634)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    filter: "url(#filter9_i_434_3634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M24.5 22C24.5 21.7348 24.6054 21.4804 24.7929 21.2929C24.9804 21.1054 25.2348 21 25.5 21H30.5V23H25.5C25.2348 23 24.9804 22.8946 24.7929 22.7071C24.6054 22.5196 24.5 22.2652 24.5 22Z",
    fill: "url(#paint35_linear_434_3634)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    filter: "url(#filter10_i_434_3634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M17.1805 13.0161H15.8195C15.6538 13.0161 15.5195 13.1504 15.5195 13.3161V14.6761C15.5195 14.8418 15.6538 14.9761 15.8195 14.9761H17.1805C17.3462 14.9761 17.4805 14.8418 17.4805 14.6761V13.3161C17.4805 13.1504 17.3462 13.0161 17.1805 13.0161Z",
    fill: "url(#paint36_linear_434_3634)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    filter: "url(#filter11_i_434_3634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M13.1805 13.0161H11.8195C11.6538 13.0161 11.5195 13.1504 11.5195 13.3161V14.6761C11.5195 14.8418 11.6538 14.9761 11.8195 14.9761H13.1805C13.3462 14.9761 13.4805 14.8418 13.4805 14.6761V13.3161C13.4805 13.1504 13.3462 13.0161 13.1805 13.0161Z",
    fill: "url(#paint37_linear_434_3634)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    filter: "url(#filter12_i_434_3634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M5.18053 16.02H3.81953C3.65385 16.02 3.51953 16.1543 3.51953 16.32V17.68C3.51953 17.8457 3.65385 17.98 3.81953 17.98H5.18053C5.34622 17.98 5.48053 17.8457 5.48053 17.68V16.32C5.48053 16.1543 5.34622 16.02 5.18053 16.02Z",
    fill: "url(#paint38_linear_434_3634)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    filter: "url(#filter13_i_434_3634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M5.18053 20.02H3.81953C3.65385 20.02 3.51953 20.1543 3.51953 20.32V21.68C3.51953 21.8457 3.65385 21.98 3.81953 21.98H5.18053C5.34622 21.98 5.48053 21.8457 5.48053 21.68V20.32C5.48053 20.1543 5.34622 20.02 5.18053 20.02Z",
    fill: "url(#paint39_linear_434_3634)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    filter: "url(#filter14_i_434_3634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M5.18053 24.02H3.81953C3.65385 24.02 3.51953 24.1543 3.51953 24.32V25.68C3.51953 25.8457 3.65385 25.98 3.81953 25.98H5.18053C5.34622 25.98 5.48053 25.8457 5.48053 25.68V24.32C5.48053 24.1543 5.34622 24.02 5.18053 24.02Z",
    fill: "url(#paint40_linear_434_3634)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    filter: "url(#filter15_i_434_3634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M17.1805 17.02H15.8195C15.6538 17.02 15.5195 17.1543 15.5195 17.32V18.68C15.5195 18.8457 15.6538 18.98 15.8195 18.98H17.1805C17.3462 18.98 17.4805 18.8457 17.4805 18.68V17.32C17.4805 17.1543 17.3462 17.02 17.1805 17.02Z",
    fill: "url(#paint41_linear_434_3634)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    filter: "url(#filter16_i_434_3634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M17.1805 21.0239H15.8195C15.6538 21.0239 15.5195 21.1582 15.5195 21.3239V22.6839C15.5195 22.8496 15.6538 22.9839 15.8195 22.9839H17.1805C17.3462 22.9839 17.4805 22.8496 17.4805 22.6839V21.3239C17.4805 21.1582 17.3462 21.0239 17.1805 21.0239Z",
    fill: "url(#paint42_linear_434_3634)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    filter: "url(#filter17_i_434_3634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M17.1805 25.0291H15.8195C15.6538 25.0291 15.5195 25.1634 15.5195 25.3291V26.6891C15.5195 26.8547 15.6538 26.9891 15.8195 26.9891H17.1805C17.3462 26.9891 17.4805 26.8547 17.4805 26.6891V25.3291C17.4805 25.1634 17.3462 25.0291 17.1805 25.0291Z",
    fill: "url(#paint43_linear_434_3634)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    filter: "url(#filter18_i_434_3634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M13.1805 17.02H11.8195C11.6538 17.02 11.5195 17.1543 11.5195 17.32V18.68C11.5195 18.8457 11.6538 18.98 11.8195 18.98H13.1805C13.3462 18.98 13.4805 18.8457 13.4805 18.68V17.32C13.4805 17.1543 13.3462 17.02 13.1805 17.02Z",
    fill: "url(#paint44_linear_434_3634)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    filter: "url(#filter19_i_434_3634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M13.1805 21.0239H11.8195C11.6538 21.0239 11.5195 21.1582 11.5195 21.3239V22.6839C11.5195 22.8496 11.6538 22.9839 11.8195 22.9839H13.1805C13.3462 22.9839 13.4805 22.8496 13.4805 22.6839V21.3239C13.4805 21.1582 13.3462 21.0239 13.1805 21.0239Z",
    fill: "url(#paint45_linear_434_3634)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    filter: "url(#filter20_i_434_3634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M13.1805 25.0291H11.8195C11.6538 25.0291 11.5195 25.1634 11.5195 25.3291V26.6891C11.5195 26.8547 11.6538 26.9891 11.8195 26.9891H13.1805C13.3462 26.9891 13.4805 26.8547 13.4805 26.6891V25.3291C13.4805 25.1634 13.3462 25.0291 13.1805 25.0291Z",
    fill: "url(#paint46_linear_434_3634)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_434_3634",
    x: 2.5,
    y: 2,
    width: 28.2,
    height: 28.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2,
    dy: 0.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.772549 0 0 0 0 0.294118 0 0 0 0 0.317647 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3634"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_434_3634",
    x: 24.25,
    y: 1.47998,
    width: 7.13281,
    height: 20.5959,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_434_3634"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_434_3634",
    x: 12.8277,
    y: 5.42456,
    width: 14.9711,
    height: 14.9721,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.3,
    dy: 0.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.921569 0 0 0 0 0.47451 0 0 0 0 0.133333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_434_3634"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_434_3634",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_434_3634",
    x: 18.3,
    y: 16,
    width: 10.2,
    height: 14.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.2,
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.305882 0 0 0 0 0.447059 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3634"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_434_3634",
    x: 4.3,
    y: 5.8,
    width: 9.4,
    height: 24.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.2,
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.376471 0 0 0 0 0.298039 0 0 0 0 0.454902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3634"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.294118 0 0 0 0 0.184314 0 0 0 0 0.341176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3634",
    result: "effect2_innerShadow_434_3634"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_434_3634",
    x: 23.3,
    y: 19,
    width: 7.4,
    height: 11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.239216 0 0 0 0 0.141176 0 0 0 0 0.435294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3634"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.376471 0 0 0 0 0.32549 0 0 0 0 0.580392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3634",
    result: "effect2_innerShadow_434_3634"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_434_3634",
    x: 2.3,
    y: 14,
    width: 5.2,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.454902 0 0 0 0 0.427451 0 0 0 0 0.643137 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3634"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_ii_434_3634",
    x: 9.3,
    y: 11,
    width: 12.4,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.486275 0 0 0 0 0.431373 0 0 0 0 0.619608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3634"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.345098 0 0 0 0 0.231373 0 0 0 0 0.505882 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3634",
    result: "effect2_innerShadow_434_3634"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_434_3634",
    x: 24.5,
    y: 25,
    width: 6.1,
    height: 2.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.905882 0 0 0 0 0.635294 0 0 0 0 0.4 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3634"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_434_3634",
    x: 24.5,
    y: 21,
    width: 6.1,
    height: 2.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.905882 0 0 0 0 0.635294 0 0 0 0 0.4 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3634"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_i_434_3634",
    x: 15.3195,
    y: 13.0161,
    width: 2.16094,
    height: 2.15996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.2,
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.121569 0 0 0 0 0.0705882 0 0 0 0 0.14902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3634"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_434_3634",
    x: 11.3195,
    y: 13.0161,
    width: 2.16094,
    height: 2.15996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.2,
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.956863 0 0 0 0 0.690196 0 0 0 0 0.34902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3634"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_i_434_3634",
    x: 3.31953,
    y: 16.02,
    width: 2.16094,
    height: 2.15996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.2,
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.121569 0 0 0 0 0.0705882 0 0 0 0 0.14902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3634"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_i_434_3634",
    x: 3.31953,
    y: 20.02,
    width: 2.16094,
    height: 2.15996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.2,
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.956863 0 0 0 0 0.690196 0 0 0 0 0.34902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3634"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_i_434_3634",
    x: 3.31953,
    y: 24.02,
    width: 2.16094,
    height: 2.15996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.2,
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.956863 0 0 0 0 0.690196 0 0 0 0 0.34902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3634"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_i_434_3634",
    x: 15.3195,
    y: 17.02,
    width: 2.16094,
    height: 2.15996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.2,
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.956863 0 0 0 0 0.690196 0 0 0 0 0.34902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3634"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_i_434_3634",
    x: 15.3195,
    y: 21.0239,
    width: 2.16094,
    height: 2.15996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.2,
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.956863 0 0 0 0 0.690196 0 0 0 0 0.34902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3634"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_i_434_3634",
    x: 15.3195,
    y: 25.0291,
    width: 2.16094,
    height: 2.15996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.2,
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.121569 0 0 0 0 0.0705882 0 0 0 0 0.14902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3634"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_i_434_3634",
    x: 11.3195,
    y: 17.02,
    width: 2.16094,
    height: 2.15996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.2,
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.956863 0 0 0 0 0.690196 0 0 0 0 0.34902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3634"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_i_434_3634",
    x: 11.3195,
    y: 21.0239,
    width: 2.16094,
    height: 2.15996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.2,
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.121569 0 0 0 0 0.0705882 0 0 0 0 0.14902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3634"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_i_434_3634",
    x: 11.3195,
    y: 25.0291,
    width: 2.16094,
    height: 2.15996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.2,
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.956863 0 0 0 0 0.690196 0 0 0 0 0.34902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3634"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_434_3634",
    x1: 19.237,
    y1: 2,
    x2: 19.237,
    y2: 21.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E55057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    stopColor: "#FF8C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_434_3634",
    x1: 27.816,
    y1: 4.22898,
    x2: 27.816,
    y2: 19.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F96B70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_434_3634",
    x1: 26.1232,
    y1: 6.37401,
    x2: 15.8562,
    y2: 19.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E37C1E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_434_3634",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.2712 4.08001) rotate(138.155) scale(2.52745 2.23)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA13D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_434_3634",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.6952 3.28301) rotate(67.811) scale(4.01805 3.54516)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA13D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_434_3634",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.4862 7.03001) rotate(-164.745) scale(1.60205 2.21825)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA13D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_434_3634",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.7179 9.36267) rotate(154.195) scale(2.84051 2.09792)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA13D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_434_3634",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.3362 14.168) rotate(-173.379) scale(3.16853 1.78558)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA13D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_434_3634",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.4975 17.8497) rotate(-43.964) scale(2.87412 2.76888)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0762A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_434_3634",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1775 17.1748) rotate(-127.747) scale(2.20344 2.12276)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0762A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_434_3634",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.1712 9.72801) rotate(25.278) scale(2.23758 2.70444)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0851D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0851D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_434_3634",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9002 6.42401) rotate(-57.2648) scale(2.81624 1.23273)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC8A15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC8A15",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_434_3634",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.2852 8.98401) rotate(-31.7593) scale(1.5672 1.20152)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC8A15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC8A15",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_434_3634",
    x1: 26.1232,
    y1: 6.37401,
    x2: 15.8562,
    y2: 19.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E37C1E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_434_3634",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.2712 4.08001) rotate(138.155) scale(2.52745 2.23)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA13D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_434_3634",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.6952 3.28301) rotate(67.811) scale(4.01805 3.54516)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA13D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_434_3634",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.4862 7.03001) rotate(-164.745) scale(1.60205 2.21825)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA13D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_434_3634",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.7179 9.36267) rotate(154.195) scale(2.84051 2.09792)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA13D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_434_3634",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.3362 14.168) rotate(-173.379) scale(3.16853 1.78558)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA13D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_434_3634",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.4975 17.8497) rotate(-43.964) scale(2.87412 2.76888)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0762A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_434_3634",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1775 17.1748) rotate(-127.747) scale(2.20344 2.12276)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0762A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_434_3634",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.1712 9.72801) rotate(25.278) scale(2.23758 2.70444)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0851D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0851D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_434_3634",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9002 6.42401) rotate(-57.2648) scale(2.81624 1.23273)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC8A15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC8A15",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_434_3634",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.8352 13.277) rotate(1.97481) scale(2.45502 1.59781)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC8A15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC8A15",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_434_3634",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.4892 16.366) rotate(-54.7131) scale(1.6843 1.61444)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF7630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF7630",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_434_3634",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.6057 8.44707) rotate(117.739) scale(12.8223 18.4376)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#FFE229"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA21C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_434_3634",
    x1: 21.563,
    y1: 28.845,
    x2: 21.551,
    y2: 19.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    stopColor: "#37204D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37204D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_434_3634",
    x1: 23.5,
    y1: 16,
    x2: 23.5,
    y2: 16.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#472E5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#472E5B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_434_3634",
    x1: 7.295,
    y1: 25.759,
    x2: 7.142,
    y2: 12.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#2F1B3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F1942",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_434_3634",
    x1: 27.583,
    y1: 19,
    x2: 27.583,
    y2: 25.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F4C98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C3F8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_434_3634",
    x1: 5.417,
    y1: 14,
    x2: 5.417,
    y2: 23.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6759A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E418D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_434_3634",
    x1: 5,
    y1: 14,
    x2: 5,
    y2: 14.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#645191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#645191",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_434_3634",
    x1: 16.5,
    y1: 11,
    x2: 16.5,
    y2: 22.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D408E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_434_3634",
    x1: 15.5,
    y1: 11,
    x2: 15.5,
    y2: 11.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#585495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#585495",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_434_3634",
    x1: 27.5,
    y1: 25.556,
    x2: 27.5,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFD6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_434_3634",
    x1: 27.5,
    y1: 21.556,
    x2: 27.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFD6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_434_3634",
    x1: 17.4795,
    y1: 13.0161,
    x2: 15.5195,
    y2: 14.9761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373638"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_434_3634",
    x1: 13.4795,
    y1: 13.4331,
    x2: 11.8745,
    y2: 14.9761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_434_3634",
    x1: 5.47953,
    y1: 16.02,
    x2: 3.51953,
    y2: 17.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373638"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_434_3634",
    x1: 5.47953,
    y1: 20.438,
    x2: 3.87453,
    y2: 21.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_434_3634",
    x1: 5.47953,
    y1: 24.438,
    x2: 3.87453,
    y2: 25.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_434_3634",
    x1: 17.4795,
    y1: 17.438,
    x2: 15.8745,
    y2: 18.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_434_3634",
    x1: 17.4795,
    y1: 21.4419,
    x2: 15.8745,
    y2: 22.9839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_434_3634",
    x1: 17.4795,
    y1: 25.0291,
    x2: 15.5195,
    y2: 26.9891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373638"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_434_3634",
    x1: 13.4795,
    y1: 17.438,
    x2: 11.8745,
    y2: 18.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_434_3634",
    x1: 13.4795,
    y1: 21.0239,
    x2: 11.5195,
    y2: 22.9839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373638"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_434_3634",
    x1: 13.4795,
    y1: 25.4461,
    x2: 11.8745,
    y2: 26.9891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF80"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentEmojiSunset);
export default __webpack_public_path__ + "static/media/fluent-emoji_sunset.11015965030bb10f831d4cbf893087f4.svg";
export { ForwardRef as ReactComponent };